import React, { useState, useEffect, useCallback } from 'react'
import { RadioGroup } from '@headlessui/react';
import axios from 'axios';
import { StarIcon } from '@heroicons/react/20/solid';
import { ClockIcon, BoltIcon, ShareIcon, ShoppingCartIcon } from '@heroicons/react/24/outline';
import { AddtocardList, getProducts } from './../Redux/action';
import { useDispatch, useSelector } from 'react-redux';
import {
    useParams, useNavigate, useLocation
} from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import toast from 'react-hot-toast';
import Logo from './../assist/triokzzlohgo.svg';
import PaymentOptions from './../assist/paymentoption.jpg'
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import ShoppingCard from './shoppingCard';
// import GoogleReviews from "./../about/googleReview.js";
import Video from "./../about/video.js"
import Chatbot from './chatbot.js'
import OptimizedImage from './../about/optimizedImages.js';
import { FirebaseViewers } from './../Notification/firebase.js';
import { categories } from './../hooks/productsJson.js';

const steps = [
    {
        id: 'welcome',
        message: 'Welcome to Triokzz 👋 I am Ghanashyam. How can I help you today?',
        trigger: 'askName'
    },

    {
        id: 'askName',
        message: 'May I know your name?',
        trigger: 'getName'
    },

    {
        id: 'getName',
        user: true,
        trigger: 'mainMenu'
    },

    {
        id: 'mainMenu',
        message: 'Hi {previousValue} 😊 Please choose your query:',
        trigger: 'faqOptions'
    },

    {
        id: 'faqOptions',
        options: [
            { value: 'shipping', label: '🚚 Shipping Info', trigger: 'shippingReply' },
            { value: 'payment', label: '💳 Payment Methods', trigger: 'paymentReply' },
            { value: 'return', label: '🔁 Return Policy', trigger: 'returnReply' },
            { value: 'order', label: '📦 Track Order', trigger: 'orderReply' },
            { value: 'agent', label: '💬 Talk to Human (WhatsApp)', trigger: 'whatsapp' }
        ]
    },

    {
        id: 'shippingReply',
        message: 'We deliver orders within 3–7 business days across India 🚚',
        trigger: 'askMore'
    },

    {
        id: 'paymentReply',
        message: 'We accept UPI, Debit/Credit Cards, Net Banking and Cash on Delivery 💳',
        trigger: 'askMore'
    },

    {
        id: 'returnReply',
        message: 'You can return products within 7 days of delivery. Refund will be processed in 3 working days 🔁',
        trigger: 'askMore'
    },

    {
        id: 'orderReply',
        message: 'Please keep your Order ID ready. Our support team will help you track it 📦',
        trigger: 'whatsapp'
    },

    {
        id: 'askMore',
        message: 'Do you need more help?',
        trigger: 'moreOptions'
    },

    {
        id: 'moreOptions',
        options: [
            { value: 'yes', label: 'Yes 👍', trigger: 'faqOptions' },
            { value: 'no', label: 'Talk to Human 💬', trigger: 'whatsapp' }
        ]
    },

    {
        id: 'whatsapp',
        component: (
            <a
                href="https://wa.me/9096324272?text=Hi%20Triokzz%20I%20need%20support"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    background: "#25D366",
                    color: "white",
                    padding: "10px 16px",
                    borderRadius: "8px",
                    display: "inline-block",
                    marginTop: "10px",
                    textDecoration: "none",
                    fontWeight: "bold"
                }}
            >
                Chat on WhatsApp 💬
            </a>
        ),
        end: true
    }

];

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export const TimeLeftUi = () => {
    const [timeLeft, setTimeLeft] = useState({
        hours: 2,
        minutes: 45,
        seconds: 30,
    });

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft((prev) => {
                if (prev.seconds > 0) {
                    return { ...prev, seconds: prev.seconds - 1 };
                } else if (prev.minutes > 0) {
                    return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
                } else if (prev.hours > 0) {
                    return {
                        hours: prev.hours - 1,
                        minutes: 59,
                        seconds: 59,
                    };
                }
                return prev;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, []);
    return (
        <div>
            <div className="animate-grid-color [animation-delay:2s] text-white">
                <div className="container mx-auto px-4 py-6">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                        {/* Main Offer Text */}
                        <div className="flex items-center gap-2">
                            <div className="bg-white/20 p-2 rounded-full">
                                <BoltIcon className="w-6 h-6 fill-white" />
                            </div>
                            <div>
                                <h2 className="text-md font-bold">Get 10% Off over ₹999 /-🎁</h2>
                                <p className="text-white/90 text-sm">
                                    Limited time offer. Coupon:TRIOK10
                                </p>
                            </div>
                        </div>

                        {/* Countdown Timer */}
                        <div className="flex items-center gap-2">
                            <div className="flex items-center gap-2">
                                <ClockIcon className="w-5 h-5" />
                                <span className="text-sm font-medium">Hurry up! Offer Ends in:</span>
                            </div>
                            <div className="flex gap-2">
                                <div className="bg-white/20 backdrop-blur-sm  rounded-lg min-w-[60px] text-center">
                                    <div className="text-md font-bold">
                                        {String(timeLeft.hours).padStart(2, '0')}
                                    </div>
                                    <div className="text-xs text-white/80">Hours</div>
                                </div>
                                <div className="bg-white/20 backdrop-blur-sm  rounded-lg min-w-[60px] text-center">
                                    <div className="text-md font-bold">
                                        {String(timeLeft.minutes).padStart(2, '0')}
                                    </div>
                                    <div className="text-xs text-white/80">Mins</div>
                                </div>
                                <div className="bg-white/20 backdrop-blur-sm  rounded-lg min-w-[60px] text-center">
                                    <div className="text-md font-bold">
                                        {String(timeLeft.seconds).padStart(2, '0')}
                                    </div>
                                    <div className="text-xs text-white/80">Secs</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const TimerCount = () => {
    const [cartTimer, setCartTimer] = useState(599)

    useEffect(() => {
        const t = setInterval(() => setCartTimer((s) => (s > 0 ? s - 1 : 0)), 1000)
        return () => clearInterval(t)
    }, [])

    const timerMin = String(Math.floor(cartTimer / 60)).padStart(2, "0")
    const timerSec = String(cartTimer % 60).padStart(2, "0")
    return (
        <div className="bg-red-600 px-5 py-2.5 flex items-center justify-between flex-shrink-0">
            <div className="flex items-center gap-2">
                <span className="text-base">⏰</span>
                <span className="text-white text-xs font-semibold">Prices reserved for</span>
            </div>
            <div className="flex items-center gap-1.5">
                <span className="bg-white text-red-600 font-poppins font-black text-sm px-2 py-0.5 rounded tabular-nums">{timerMin}</span>
                <span className="text-white font-bold">:</span>
                <span className="bg-white text-red-600 font-poppins font-black text-sm px-2 py-0.5 rounded tabular-nums">{timerSec}</span>
            </div>
        </div>
    )
}
const ProductPage = (props) => {
    const { item, subproduct } = useParams()
    const location = useLocation();
    const [subNavItem, setSubNavItem] = useState(subproduct)
    const [navItem, setNavItem] = useState(item)
    const [serchableoutput, setserchableoutput] = useState()
    const [open, setOpen] = useState(props.open)
    const [count, setarr] = useState(new Array(1).fill(null).map((_, i) => i))
    const [selectedColor, setSelectedColor] = useState("")
    const [selectedSize, setSelectedSize] = useState([])
    const [quantity, setQuantity] = useState(1)
    const [relevantProduct, setRelevantProduct] = useState([])
    const [updatedTime, setUpdatedTime] = useState('');
    const [addtocard, setAddtocard] = useState([])
    const [openshopping, setOpenShopping] = useState(false)
    const [showChild, setShowChild] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [productReview, setProductReview] = useState("EX.Best purchase I've made this year! The cushioning is fantastic and the style is very versatile. Highly recommend!")
    // let session = JSON.parse(localStorage.getItem('PHONEOTPINFO'))
    // let siginUserInfo = JSON.parse(localStorage.getItem('signiniNFO'))
    const [selectedImage, setSelectedImage] = useState(0);
    const [isZoomed, setIsZoomed] = useState(false);
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [chattoggle, setChatToggle] = useState(false)
    const [category, setCategory] = useState();
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [recentBuyer, setRecentBuyer] = useState(0)
    const recentBuyers = ["Priya from Mumbai", "Rahul from Delhi", "Anita from Bengaluru", "Sonia from Pune", "Deepak from Hyderabad", "Siya from Kolkata", "Rohit from jalgaon", "Ramani from thane"]

    // console.log(subNavItem, item)
    useEffect(() => {
        const t = setInterval(() => setRecentBuyer(b => (b + 1) % recentBuyers.length), 8000)
        return () => clearInterval(t)
    }, [])
    //onback popup close
    useEffect(() => {
        // console.log(item, subproduct)
        async function fetchData() {
            // console.log("asasa")
            let searchableoutput = []
            try {
                let serching = subproduct && subproduct.toLowerCase()
                if (serching && serching.length > 2) {
                    let TrendingProductsforsearch = await axios.get("https://kqej90wmli.execute-api.ap-south-1.amazonaws.com/dev/products")
                        .then(r => r)
                        .then(res => res.data)
                        .catch(err => console.log(err))


                    TrendingProductsforsearch && TrendingProductsforsearch.products && TrendingProductsforsearch.products.find((val, i, arr) => {
                        if (val.product_for !== item) return false;
                        let search = val && val.section && val.section.filter((items, i) => {
                            let [keys] = Object.keys(items)
                            let arr = items[keys]

                            return arr.some((prod) => subproduct.includes(prod.id));

                        })

                        search.map((v, i) => {
                            let [keys] = Object.keys(v)
                            let arr = v[keys]
                            const filteredval = arr.filter(info => {
                                // console.log(info.size[0])
                                return serching.includes((info && info.id && info.id.toLowerCase()))
                            }
                            )
                            if (filteredval.length) {
                                let brandSearch = filteredval && filteredval[0] && filteredval[0].brand
                                const OtherProducts = arr.filter(info => {
                                    return brandSearch.includes((info && info.brand))
                                })
                                setSelectedSize(filteredval && filteredval[0] && filteredval[0].size[0])
                                setSelectedColor(filteredval && filteredval[0] && filteredval[0].color)
                                // navigate(`/amazing-product/${navItem}/${product.type}${product.id}`)
                                setserchableoutput(filteredval)
                                setRelevantProduct(OtherProducts)
                            }
                        })
                    })
                }
            } catch (err) {
                console.log(err);
            } finally {
                setIsLoading(false); // Stop loading regardless of success or error
            }
        }

        fetchData();

    }, [item, location])

    //   zoomin fuctionality
    const handleMouseMove = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        console.log(rect)
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        setMousePosition({ x, y });
    };

    // console.log(navItem)
    const onshoppingRender = useCallback(() => {
        return setOpenShopping(true)
    }, [])

    const onAddToCard = (cardproducts) => {
        // console.log(cardproducts)
        // setTimeout(() => {
        let somthing = addtocard && addtocard.find((val) => {
            // console.log(val, cardproducts.id)
            return val.id == cardproducts.id
        })
        // console.log(somthing)
        if (somthing) {
            let filtereditem = addtocard && addtocard.filter((val) => {
                // console.log(val)
                return val.id !== cardproducts.id
            })
            let items = filtereditem.concat(cardproducts)
            setAddtocard(items)
            localStorage.setItem("addtocard", JSON.stringify(items))
            dispatch(AddtocardList(items))
            onshoppingRender()
        } else
            if (somthing == undefined) {
                let items = addtocard && addtocard.concat(cardproducts)
                setAddtocard(items)
                localStorage.setItem("addtocard", JSON.stringify(items))
                dispatch(AddtocardList(items))
                onshoppingRender()
            } else {
                onshoppingRender()
            }
        // analytics.logEvent('add_to_cart')
        toast(
            <span>
                <b>We saved your cart! Complete checkout now to avoid missing out.</b>
            </span>,
            {
                icon: '🔥',
            },
            {
                duration: 2000,
            }
        )
        // }, 100)

        if (window.gtag) {
            window.gtag('event', 'conversion', {
                send_to: 'AW-11415759693/5sa9CJmbsZEZEM3WusMq',
                value: cardproducts && cardproducts.price,       // replace with dynamic total
                currency: 'INR',
                transaction_id: cardproducts && cardproducts.id
            });
            window.gtag('event', 'conversion', {
                send_to: 'AW-11415759693/haFsCPXm5_cYEM3WusMq',
                value: cardproducts && cardproducts.price,       // replace with dynamic total
                currency: 'INR',
                transaction_id: cardproducts && cardproducts.id
            });

            // ✅ Also fire standard GA4 add_to_cart event for Google Analytics reports
            window.gtag('event', 'add_to_cart', {
                currency: 'INR',
                value: cardproducts && cardproducts.price,
                items: [{
                    item_id: cardproducts && cardproducts.id,
                    item_name: cardproducts && cardproducts.product_name,
                    price: cardproducts && cardproducts.price,
                    quantity: 1
                }]
            });
        }
        if (typeof window.fbq === 'function') {
            window.fbq('track', 'ViewContent', {
                content_ids: [cardproducts && cardproducts.id], // 'REQUIRED': array of product IDs
                content_type: 'product', // RECOMMENDED: Either product or product_group based on the content_ids or contents being passed.
            });
            window.fbq('track', 'AddToCart', {
                content_ids: [cardproducts && cardproducts.id], // 'REQUIRED': array of product IDs
                value: cardproducts && cardproducts.price + ".00", // REQUIRED, up to 2 decimals optional
                currency: 'INR',
                content_type: 'product', // RECOMMENDED: Either product or product_group based on the content_ids or contents being passed.
            });
        }
    }

    const onRemove = (item, index) => {
        const removeItem = addtocard && addtocard.filter((value, i) => {
            return i !== index
        })
        setAddtocard(removeItem)
        localStorage.setItem("addtocard", JSON.stringify(removeItem))
        dispatch(AddtocardList(removeItem))
    }

    const onCount = (e, id, index) => {
        var a = addtocard && addtocard.find((val, i) => val.id == id)
        // console.log(a.id, id)
        if (a.id == id) {
            addtocard[index].count = e.target.value
            localStorage.setItem("addtocard", JSON.stringify(addtocard))
        }
    }
    useEffect(() => {
        const getitem = localStorage.getItem("addtocard")
        if (getitem != null) {
            setAddtocard(JSON.parse(getitem))
            dispatch(AddtocardList(JSON.parse(getitem)))
        }
    }, [])
    //   console.log(subNavItem)
    const scrolltobottom = () => {
        window.scroll({
            top: 30,
            left: 0,
            behavior: "smooth",
        })
    }
    const onOpen = (product, shopping_card_id) => {
        setSubNavItem(product.type + product.id)
        setNavItem(product.navItem)
        // console.log(product.navItem)
        navigate(`/amazing-product/${product.navItem}/${product.type}${product.id}`)

        scrolltobottom()
    }

    const increment = () => {
        if (quantity == 10) {
            setQuantity(10)
        } else {
            setQuantity(quantity + 1)
        }
    }

    const decrement = () => {
        if (quantity == 1) {
            setQuantity(1)
        } else {
            setQuantity(quantity - 1)
        }

    }

    useEffect(() => {
        // Set the updated time when the component is mounted or when the content changes
        const currentTime = new Date().toISOString();
        setUpdatedTime(currentTime);
    }, []); // Empty array means it runs only once when the component mounts


    // console.log(subNavItem)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const whatsappMe = () => {
        setChatToggle(!chattoggle)
    }

    // sroll on navigator works
    useEffect(() => {
        let lastScrollY = window.scrollY;
        const navbar = document.getElementById('bottom-navigation');

        const handleScroll = () => {
            if (window.scrollY > lastScrollY) {
                navbar?.classList.remove("hidden");
            } else {
                navbar?.classList.add("hidden");
            }
            lastScrollY = window.scrollY;
        };

        // ✅ passive: true — tells browser this won't call preventDefault()
        window.addEventListener('scroll', handleScroll, { passive: true });
        // ✅ Always clean up in React
        return () => window.removeEventListener('scroll', handleScroll);

    }, [window.scrollY])

    const checkout = (items) => {

        // if (siginUserInfo) {
        dispatch(AddtocardList(items))
        setTimeout(() => {
            navigate(`/paymentgetway`)
        }, 1000)
        // } else {
        //     setShowChild(true)
        // }
        if (window.gtag) {
            // window.gtag('event', 'conversion', {
            //     send_to: 'AW-11415759693/5sa9CJmbsZEZEM3WusMq',
            //     value: items && items[0].price,       // replace with dynamic total
            //     currency: 'INR',
            //     transaction_id: items && items[0].id
            // });
            // window.gtag('event', 'conversion', {
            //     send_to: 'AW-11415759693/haFsCPXm5_cYEM3WusMq',
            //     value: items && items[0].price,       // replace with dynamic total
            //     currency: 'INR',
            //     transaction_id: items && items[0].id
            // });

            //Ad conversion tracking
            window.gtag('event', 'conversion', {
                send_to: 'AW-11415759693/QtgvCJ6asZEZEM3WusMq',
            });
            //Ga4 begin checkout tag
            window.gtag('event', 'begin_checkout', {
                currency: 'INR',
                value: items && items[0].price,
                // items: addtocards && addtocards[0].,
                items: [
                    {
                        item_id: items && items[0].id,
                        item_name: items && items[0].product_name,
                        price: items && items[0].price,
                        quantity: items && items[0].count
                    }
                ]
            })
        }
        if (typeof window.fbq === 'function' && window.fbq.loaded) {
            window.fbq('track', 'ViewContent', {
                content_ids: [items && items[0].id], // 'REQUIRED': array of product IDs
                content_type: 'product', // RECOMMENDED: Either product or product_group based on the content_ids or contents being passed.
            });
            window.fbq('track', 'AddToCart', {
                content_ids: [items && items[0].id], // 'REQUIRED': array of product IDs
                value: items && items[0].price + ".00", // REQUIRED, up to 2 decimals optional
                currency: 'INR',
                content_type: 'product', // RECOMMENDED: Either product or product_group based on the content_ids or contents being passed.
            });
        }
    }



    const handleShare = async (val) => {
        const shareData = {
            title: `*${val.product_name}*`,
            text: `⚡️ Big season. Bigger discount.
*${val.product_name}*

*At ₨ ${val.offer_prize} /-* 😮.
~M.R.P ₨ ${val.real_prize} /-~
*${val.offer}* 

_${((val.product_detail).substr(20, 80)).replace(/<[^>]*>/g, '*')}*_✍︎read more
Namaskaram
`,
            url: window.location.href
        };

        // Try to fetch and share with image on supported platforms
        if (navigator.share && navigator.canShare) {
            try {
                // Try to fetch the image and convert to blob for sharing
                const response = await fetch(val.image);
                const blob = await response.blob();
                const file = new File([blob], 'product.jpg', { type: blob.type });

                const shareDataWithImage = {
                    ...shareData,
                    files: [file]
                };

                // Check if we can share with files
                if (navigator.canShare(shareDataWithImage)) {
                    await navigator.share(shareDataWithImage);
                    toast.success('Shared successfully!');
                    return;
                }
            } catch (err) {
                // If image sharing fails, try without image
                console.log('Image sharing not supported, trying without image');
            }

            // Fallback to sharing without image
            try {
                await navigator.share(shareData);
                toast.success('Shared successfully!');
                return;
            } catch (err) {
                if (err instanceof Error && err.name !== 'AbortError') {
                    // Show share modal instead
                    copyToClip();
                }
            }
        } else {
            // Show share modal for desktop/unsupported browsers
            copyToClip();
        }
    };


    async function copyToClip() {

        await navigator.clipboard.writeText(window.location.href);
        toast('Link, Copied to Clipboard !')
    }

    // Helper function to split text on full stops and create list items
    const splitToList = (text) => {
        return text
            .split('. ')
            .map(sentence => sentence.trim())
            .filter(sentence => sentence.length > 0);
    };


    // console.log(serchableoutput)
    return (
        <main className="z-10 pt-2 inset-0" key={navItem}>
            {/* Ticker tape */}
            <div className="scroll-left bg-violet-700 text-white overflow-hidden py-1.5">
                <div className="ticker-tape inline-flex gap-1 text-xs font-medium">

                    <span className="inline-flex gap-8">
                        <span>🔒 100% Secure Payments</span>
                        <span>🚚 Free Delivery above ₹1499</span>
                        <span>↩️ Easy 30-Day Returns</span>
                        <span>💎 Authentic Artisan Products</span>
                        <span>📦 Cash on Delivery Available</span>
                        <span>⭐ 50,000+ Happy Customers</span>
                    </span>

                </div>
            </div>
            <nav className="sticky top-0 z-10 w-full bg-white flex-col grid grid-cols-2 items-center justify-between text-black p-2" role="navigation">
                <div className="flex items-center flex-shrink-0 text-black mr-6" onClick={() => navigate(`/product/${navItem}`)}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                    </svg>
                    <img
                        className="h-10 w-25"
                        src={Logo}
                        height="100%"
                        alt="Paithani, grocery, skin care, shankara naturals, amazo, Solid T-shirt,Plain T-Shirt,Buy Plain Solid T-shirts,printo mug, Bewakoofy items, home decor items, sculptures, inspiring, large luggage bags, popular duffle, touring bags, big size travel bags online, purse, wholesale mugs, custom cups and mugs, ceramic printed mugs, copper drinking mugs, cups for camping, purses for women, purse sale, branded bags for women, multi pocket bags"
                    />
                </div>
                <div className="flex lg:ml-4 mr-2 justify-end" >
                    {/* Cart */}
                    <button
                        onClick={() => onshoppingRender()}
                        className="relative flex items-center gap-1.5 bg-violet-700 hover:bg-violet-800 text-white px-4 py-2 rounded-xl transition-colors"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                        </svg>
                        <span className="text-sm font-bold">Cart</span>
                        <span className="absolute -top-2 -right-2 bg-orange-500 text-white text-[10px] font-black w-5 h-5 rounded-full flex items-center justify-center">{addtocard && addtocard.length}</span>
                    </button>
                </div>
            </nav>

            <div className="w-full relative">
                <div className="fixed right-0 bottom-0 group z-40 speeddial-button">
                    <button type="button" aria-expanded="false" className="flex items-center justify-center text-white bg-indigo-600 rounded-full w-12 h-12 hover:bg-indigo-700 focus:ring-4 focus:outline-none" onClick={() => whatsappMe()}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
                        </svg>

                        <span className="sr-only">Open actions menu</span>
                    </button>
                </div>
            </div>
            {/* {siginUserInfo ? "" : showChild ? <OfferCard setShowChild={setShowChild} /> : ""} */}
            <h3 className='sr-only'>Triokzz {item} premium quality products, natural, and eco-friendly products. We handpick the finest brands that honor </h3>
            <h2 className="sr-only capitalize truncate text-sm w-24 text-sky-600">Triokzz coseller products, including Shankara Naturals, Kalanshuk kalanjali paithani, nath paithani, A2 bilona ghee, Saris, Ceramic mug, ghungru kadi, manas jaivik food, standerd milkcow ghee, dry fruits</h2>
            {openshopping ? <ShoppingCard openshopping={openshopping} setOpenShopping={setOpenShopping} onRemove={onRemove} onCount={onCount} onOpen={onOpen} setShowChild={setShowChild} /> : ""}
            {serchableoutput ? serchableoutput && serchableoutput.map((val, id) => {
                const breadcrumbSchema = {
                    "@context": "https://schema.org",
                    "@type": "BreadcrumbList",
                    itemListElement: [
                        { "@type": "ListItem", position: 1, name: "Home", item: "https://www.triokzz.com/" },
                        { "@type": "ListItem", position: 2, name: "Sarees", item: `https://www.triokzz.com/product/${navItem}` },
                        { "@type": "ListItem", position: 3, name: val.product_name, item: `https://www.triokzz.com/amazing-product/${navItem}/${val.type}${val.id}` },
                    ],
                };
                return (
                    <div key={id} className="min-h-full items-stretch justify-center text-center md:items-center md:px-2 lg:px-4" id="data-is-loaded-element">


                        <nav className="flex  text-gray-700 border border-gray-200 rounded-lg bg-gray-50" aria-label="Breadcrumb">
                            <ol className="inline-flex items-center space-x-1 md:space-x-3">
                                <li className="inline-flex items-center">
                                    <a href="/" className="rounded-md px-2 py-1 text-sm font-medium text-gray-400 hover:bg-gray-700 hover:text-white">Home</a>
                                </li>
                                <li aria-current="page" onClick={() => navigate(`/product/${navItem}`)}>
                                    <div className="flex items-center">
                                        <span className="mx-2 text-gray-400">/</span>
                                        <span className="text-sm font-medium text-gray-500">Category</span>
                                    </div>
                                </li>
                            </ol>
                        </nav>
                        <div className="w-full">
                            <div className="sticky bg-white shadow p-1">
                                {/* <section id="bottom-navigation" className="block fixed inset-x-0 top-20 z-10 bg-white shadow">  */}
                                <div id="tabsid" className="flex justify-between">
                                    <div id="categorytabs" className="flex justify-between">
                                        <div className="grid grid-cols-8 sm:grid-cols-8">
                                            {categories.map((cat) => (
                                                <button
                                                    key={cat.name}
                                                    onClick={() => navigate(cat.link)}
                                                    className={`flex flex-col items-center gap-2 p-3 rounded-2xl  hover:shadow-md transition-all card-hover border border-white`}
                                                >
                                                    <div
                                                        className={`w-12 h-12 rounded-full bg-gradient-to-br ${cat.color} flex items-center justify-center text-2xl shadow-md`}
                                                    >
                                                        {cat.icon}
                                                    </div>
                                                    <span className="text-xs font-semibold text-gray-700 text-center leading-tight">
                                                        {cat.name}
                                                    </span>
                                                </button>
                                            ))}

                                            {/* <a href="https://www.delhivery.com/tracking" className="w-full focus:text-teal-500 hover:text-teal-500 justify-center inline-block text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="inline-block mb-1 size-6">
                                <path d="M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 1 1 6 0h3a.75.75 0 0 0 .75-.75V15Z" />
                                <path d="M8.25 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM15.75 6.75a.75.75 0 0 0-.75.75v11.25c0 .087.015.17.042.248a3 3 0 0 1 5.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 0 0-3.732-10.104 1.837 1.837 0 0 0-1.47-.725H15.75Z" />
                                <path d="M19.5 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
                            </svg>
                            <span className="sr-only">Meet your perfect travel bags, purse, handbags companion meesh with ted beker, the Globetrotter’s Companion Travel Purse. Designed with the modern traveler in mind, this compact purse keeps your essentials organized and secure, whether you’re exploring a new city or running errands in your hometown.sculptures, inspiring, large luggage bags, popular duffle, touring bags, big size travel bags online, purse, wholesale mugs, custom cups and mugs, ceramic printed mugs, copper drinking mugs, cups for camping, purses for women, purse sale, branded bags for women, multi pocket bags</span>

                            <span className="tab tab-explore line-clamp-1 text-xs">Track order</span>
                        </a> */}
                                        </div>
                                    </div>

                                </div>
                                {/* </section> */}
                            </div>
                        </div>
                        <div className="max-w-6xl mx-auto px-4 pt-3">
                            <div className="bg-green-50 border border-green-100 rounded-xl px-4 py-2.5 flex items-center gap-2.5 text-xs mb-4">
                                <span className="text-green-500 text-lg">🛍️</span>
                                <span className="text-green-700 font-medium"><strong>{recentBuyers[recentBuyer]}</strong> just purchased this · <span className="text-green-500">2 min ago</span></span>
                            </div>
                        </div>
                        <Helmet>
                            <title>{`${val.product_name} for ${navItem} | ${val.color} | at ₹${val.offer_prize}`}</title>
                            <meta name="description"
                                content={`Buy ${val.product_name} by ${val.brand} at ₹${val.offer_prize}. ${val.product_detail.substr(0, 100)}. Free delivery above ₹1,449. In stock — order now!`} >
                            </meta>
                            <meta name="robots" content="index, follow, max-image-preview:large" />
                            {/* <meta name="google-site-verification" content="vwUAwcHi4pY-Lgm6a9JJyOwn1GLbkA7gO6fvQOy4FvU" /> */}
                            {/* <meta name="keywords" content={val.keywords.map((value, i) => value)}></meta> */}
                            <meta name="keywords" content={val.keywords.join(", ")} />
                            <link rel="canonical" href={`https://www.triokzz.com/amazing-product/${navItem}/${val.type}${val.id}`} />
                            <meta property="fb:app_id" content="1800152527554298"></meta>
                            <meta property="og:type" content="product" />
                            <meta property="og:title" content={`${val.product_name} — ₹${val.offer_prize} | ${val.type} | Triokzz`} />
                            <meta property="og:description" content={`${val.product_detail.substr(0, 100)}. Free delivery above ₹1,449.`} />

                            <meta property="product:availability" content={"in stock"} />
                            <meta property="og:image" content={`${val.url}`} />
                            <meta property="og:image:width" content="1200" />
                            <meta property="og:image:height" content="630" />
                            <meta property="og:url" content={`https://www.triokzz.com/amazing-product/${navItem}/${val.type}${val.id}`} />
                            <meta property="og:image:alt" content={`${val.product_name} by ${val.brand}`} />
                            <meta property="og:site_name" content="Triokzz" />
                            <meta property="og:image:type" content="image/webp" />
                            <meta property="og:updated_time" content={updatedTime} />
                            <meta property="og:price:amount" content={` ${val.offer_prize}`} />
                            <meta property="og:price:currency" content="INR" />
                            <meta property="og:locale" content="en_IN" />


                            <meta property="twitter:card" content="summary_large_image" />
                            <meta property="twitter:url" content={`https://www.triokzz.com/amazing-product/${navItem}/${val.type}${val.id}`} />
                            <meta property="twitter:title" content={`${val.product_name} — ₹ ${val.offer_prize} | ${val.type} | Triokzz`} />
                            <meta property="twitter:description" content={`${val.product_detail.substr(0, 130)}. Free delivery above ₹1,449.`} />
                            <meta property="twitter:image" content={`${val.url}`} />
                            <meta name="twitter:site" content="@Triokzz" />

                            <script type="application/ld+json">
                                {`
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        "name": "${val.product_name} for ${navItem} | ${val.color} at ₹ ${val.offer_prize}",
        "alternateName":[${val.keywords.map((value, i) => `"${value}"`)}],
        "image": [
            "${val.url}","${val.detail_url}"
        ],
        "description":"${val.product_detail} + ${val.type} + Shop online for exclusive deals on ${val.keywords.map((value, i) => value)}",
        "sku": "${val.id}",
        "mpn": "${val.id}-${id}",
                     "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://www.triokzz.com/search/?searchCategory=all&text={search_term_string}"
          },
          "query-input": "required name=search_term_string"
        },
        "brand": {
          "@type": "Brand",
          "name": "${val.brand}"
        },
        "review": {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": ${val.rating},
            "bestRating": 5,
            "worstRating": 1
          },
          "author": {
            "@type": "Person",
            "name": "jyotsna khadke"
          }
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": ${val.rating},
          "reviewCount": 949
        },
        "offers": {
          "@type": "Offer",
          "url": "${`https://www.triokzz.com/amazing-product/${navItem}/${val.type}${val.id}`}",
          "itemCondition": "https://schema.org/NewCondition",
          "availability": "https://schema.org/InStock",
          "price": ${val.offer_prize},
          "priceCurrency": "INR",
          "priceValidUntil": "2028-11-20",
          "shippingDetails": {
            "@type": "OfferShippingDetails",
            "shippingRate": {
              "@type": "MonetaryAmount",
              "value": 0.0,
              "currency": "INR"
            },
            "shippingDestination": {
              "@type": "DefinedRegion",
              "addressCountry": "IN"
            },
            "deliveryTime": {
              "@type": "ShippingDeliveryTime",
              "handlingTime": {
                "@type": "QuantitativeValue",
                "minValue": 0,
                "maxValue": 1,
                "unitCode": "DAY"
              },
              "transitTime": {
                "@type": "QuantitativeValue",
                "minValue": 1,
                "maxValue": 5,
                "unitCode": "DAY"
              }
            }
          },
          "hasMerchantReturnPolicy": {
            "@type": "MerchantReturnPolicy",
            "applicableCountry": "IN",
            "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
            "merchantReturnDays": 7,
            "returnMethod": "https://schema.org/ReturnByMail",
            "returnFees": "https://schema.org/FreeReturn"
          }
        }
      }
    `}
                            </script>
                            <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
                        </Helmet >

                        {!val.freez && <div className="relative hero reveal flex w-full items-center overflow-hidden bg-white px-1 pb-8 pt-2 shadow-2xl sm:px-6 sm:pt-8 md:p-6 lg:p-8">
                            {/* carousal  */}
                            {/* end carousal */}

                            <div className="w-full overflow-hidden items-start gap-x-6 gap-y-8 sm:grid-cols-12 lg:gap-x-8 p-1">

                                <Swiper
                                    slidesPerView={1}
                                    spaceBetween={5}
                                    centeredSlides={true}
                                    pagination={{
                                        clickable: true,
                                    }}
                                    modules={[Pagination]}
                                    className="mySwiper lg:w-1/2 lg:h-auto"
                                >
                                    <SwiperSlide key={1}>
                                        <div className="item-center justify-center rounded-lg sm:col-span-4 lg:col-span-2 relative aspect-square overflow-hidden cursor-zoom-in group">
                                            <OptimizedImage src={val.url} id="myImageId" style={
                                                isZoomed
                                                    ? {
                                                        transform: 'scale(2)',
                                                        transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`,
                                                        height: "100%",

                                                    }
                                                    : undefined
                                            }
                                                className={`w-full h-full aspect-square image-[rendering:pixelated] ${item == "womens" ? "" : "object-contain"} hero-image  brightness-100 blur-none`} title={val.product_name} alt={val.product_name} />
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide key={2}>
                                        <div className="item-center justify-center rounded-lg sm:col-span-4 lg:col-span-2 relative aspect-square overflow-hidden cursor-zoom-in group" >

                                            <OptimizedImage src={val.detail_url} style={
                                                isZoomed
                                                    ? {
                                                        transform: 'scale(3)',
                                                        transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`,
                                                        height: "100%"
                                                    }
                                                    : undefined
                                            } className={`h-full w-full image-[rendering:pixelated] aspect-square ${item == "womens" ? "" : "object-contain"} hero-image transition  brightness-100 blur-none`} title={val.product_name} alt={val.product_name} />
                                        </div>
                                    </SwiperSlide>
                                    {val.specified_image && <SwiperSlide key={3}>
                                        <div className="item-center justify-center rounded-lg sm:col-span-4 lg:col-span-2 relative aspect-square overflow-hidden cursor-zoom-in group" >

                                            <OptimizedImage src={val.specified_image} style={
                                                isZoomed
                                                    ? {
                                                        transform: 'scale(3)',
                                                        transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`,
                                                        height: "100%"
                                                    }
                                                    : undefined
                                            } className={`h-full w-full image-[rendering:pixelated] aspect-square ${item == "womens" ? "" : "object-contain"} hero-image  transition  brightness-100 blur-none`} title={val.product_name} alt={val.product_name} loading="lazy" />
                                        </div>
                                    </SwiperSlide>}
                                    {val.sizeguide_url && <SwiperSlide key={4}>
                                        <div className="item-center justify-center rounded-lg sm:col-span-4 lg:col-span-2 relative aspect-square overflow-hidden cursor-zoom-in group" >
                                            <OptimizedImage src={val.sizeguide_url} style={
                                                isZoomed
                                                    ? {
                                                        transform: 'scale(3)',
                                                        transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`,
                                                        height: "100%"
                                                    }
                                                    : undefined
                                            } className={`h-full w-full image-[rendering:pixelated] aspect-square ${item == "womens" ? "" : "object-contain"} hero-image transition  brightness-100 blur-none`} title={val.product_name} alt={val.product_name} loading="lazy" />
                                        </div>
                                    </SwiperSlide>}
                                </Swiper>

                                <div className='flex grid grid-cols-2 m-1 p-1'>

                                    <div
                                        className="relative h-20 w-20 aspect-square bg-gray-100 rounded-lg overflow-hidden cursor-zoom-in group m-2"
                                        onMouseEnter={() => setIsZoomed(true)}
                                        onMouseLeave={() => setIsZoomed(false)}
                                        onMouseMove={(e) => handleMouseMove(e)}
                                    >
                                        <OptimizedImage src={val.url} style={
                                            isZoomed
                                                ? {
                                                    transform: 'scale(2)',
                                                    transformOrigin: `${mousePosition.x}% ${mousePosition.y}%`
                                                }
                                                : undefined
                                        } className="w-full h-full object-cover transition-transform duration-200" title={val.product_name} alt={val.product_name} />
                                        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-2 rounded-lg shadow-md  group-hover:opacity-100 transition-opacity">
                                            <div className="flex items-center gap-2 text-sm">
                                                {/* <ZoomIn className="w-4 h-4" /> */}
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607ZM10.5 7.5v6m3-3h-6" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex float-right justify-end m-2'>
                                        <button className="bg-white " type="button" name="link" onClick={() => copyToClip()}>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>


                                <div className="space-y-2">
                                    <div className="flex items-center gap-2 ">
                                        <span className='bg-green-100 text-emerald-600 text-xs font-medium mr-2 px-1.5 py-1 rounded-full'>In Stock</span>
                                        <span className='bg-gray-100 text-emerald-600 text-xs font-medium mr-2 px-1.5 py-1 rounded-full'>100% Authentic</span>

                                    </div>
                                    {/* Trust badges row */}
                                    <div className="grid grid-cols-4 gap-2">
                                        {[
                                            { icon: "🔒", label: "Secure Pay" },
                                            { icon: "🚚", label: "Free Ship over 1449" },
                                            { icon: "↩️", label: "7'd Return" },
                                            { icon: "💎", label: "Authentic" },
                                        ].map(b => (
                                            <div key={b.label} className="bg-white rounded-xl border border-gray-100 p-2 text-center shadow-sm">
                                                <span className="text-lg block mb-0.5">{b.icon}</span>
                                                <p className="text-[10px] font-semibold text-gray-600">{b.label}</p>
                                            </div>
                                        ))}
                                    </div>

                                    <header className="hero reveal">
                                        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
                                            {/* <div className="hero-text sm:col-span-8 lg:col-span-7"> */}
                                            <span className="text-[11px] font-bold text-violet-600 uppercase tracking-wider">{val.brand}</span>
                                            <h1 className="font-poppins font-black text-xl sm:text-2xl text-gray-900 leading-tight mt-1 mb-3">{val.product_name}</h1>
                                            {/* Rating Row */}
                                            <div className="flex items-center gap-3 mb-4 flex-wrap">
                                                <div className="flex items-center gap-1">
                                                    {[1, 2, 3, 4, 5].map(s => (
                                                        <svg key={s} className={`w-4 h-4 ${s <= Math.round(val.rating) ? "text-amber-400" : "text-gray-200"}`} fill="currentColor" viewBox="0 0 20 20">
                                                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                                        </svg>
                                                    ))}
                                                </div>
                                                <span className="text-sm font-bold text-gray-700">{val.rating}</span>
                                                <FirebaseViewers /> verified reviews
                                            </div>

                                            {/* Price */}
                                            <div className="bg-gradient-to-r from-green-50 to-emerald-50 border border-green-100 rounded-xl p-4 mb-4">
                                                <div className="flex items-baseline gap-3 mb-1">
                                                    <span className="font-poppins font-black text-3xl text-gray-900">₹{val.offer_prize.toLocaleString()}</span>
                                                    <span className="text-gray-400 text-xl line-through">₹{val.real_prize.toLocaleString()}</span>
                                                    <span className="bg-green-500 text-white text-xs font-black px-2.5 py-1 rounded-full">  {Math.round(
                                                        ((val.real_prize - val.offer_prize) / val.real_prize) * 100,
                                                    )}
                                                        % OFF</span>
                                                </div>
                                                <p className="text-green-700 text-sm font-bold">🎉 You save ₹{(val.real_prize - val.offer_prize).toLocaleString()} on this item</p>
                                                <p className="text-gray-400 text-xs mt-0.5">Inclusive of all taxes · {val.offer_prize > 1449 ? "Free delivery" : ""}</p>
                                            </div>
                                            <div className="mt-4 overflow-hidden rounded-xl border-2 border-orange-300 bg-white shadow-sm">
                                                <div className="flex items-center justify-between gap-3 bg-gradient-to-r from-orange-500 to-pink-600 px-3.5 py-2">
                                                    <div className="flex items-center gap-2">
                                                        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/20 text-white">
                                                            <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                                <path strokeLinecap="round" strokeLinejoin="round" d="M20 12v8H4v-8m16 0H4m16 0h1V8h-5.2M4 12H3V8h5.2M12 8v12M12 8H8.5A2.5 2.5 0 118.5 3C10.5 3 12 8 12 8zm0 0h3.5a2.5 2.5 0 100-5C13.5 3 12 8 12 8z" />
                                                            </svg>
                                                        </span>
                                                        <span className="font-poppins text-sm font-black tracking-wide text-white">{val.offer ? val.offer : val.offer_prize > 1499 && "Free Delivery"}</span>
                                                    </div>
                                                    <span className="rounded-full bg-white px-2.5 py-1 text-[10px] font-black text-orange-600">DEAL</span>
                                                </div>
                                                <div className="grid grid-cols-2 divide-x divide-orange-100">
                                                    <div className="p-3.5">
                                                        <p className="text-[10px] font-bold uppercase tracking-wider text-gray-400">Pay on direct purchase</p>
                                                    </div>
                                                    <div className="bg-orange-50/70 p-3.5">
                                                        <button className="rounded-full bg-white px-2.5 py-2.5 text-[10px] font-black text-orange-600 animate-pulse" onClick={() => checkout([{
                                                            name: val.brand,
                                                            product_name: val.product_name,
                                                            price: val.offer_prize,
                                                            id: val.id,
                                                            count: quantity,
                                                            rating: 4.5,
                                                            reviewCount: 117,
                                                            imageSrc: val.url,
                                                            imageAlt: productReview,
                                                            colors: { name: selectedColor, class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
                                                            sizes: { name: selectedSize, inStock: true },
                                                            type: val.type,
                                                            detail: val.product_name,
                                                            delivery_charge: val.delivery_charge,
                                                            ...(val.offer && { "offer": val.offer })
                                                        }])}>
                                                            Apply to Buy
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Stock + Timer urgency */}
                                            <div className="flex flex-wrap items-center gap-3 mb-4">
                                                <div className="flex items-center gap-2 bg-red-50 border border-red-100 rounded-xl px-3 py-2">
                                                    <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse" />
                                                    {/* <span className="text-red-700 text-xs font-bold">Deal ends in</span> */}
                                                    {/* <span className="bg-red-600 text-white font-black text-xs px-2 py-0.5 rounded tabular-nums">{tMin}:{tSec}</span> */}
                                                    <TimerCount />
                                                </div>

                                                <div className="bg-amber-50 border border-amber-100 rounded-xl px-3 py-2">
                                                    <span className="text-amber-700 text-xs font-bold">⚡ Win upto ₹50 cashback on Amazon pay balance wallet</span>
                                                </div>

                                            </div>
                                            <div className='grid grid-cols-2 justify-between border-b'>
                                                <div className="mb-4">

                                                    <div className="flex gap-2 flex-wrap">
                                                        <p className="text-sm font-semibold text-gray-700 mb-2">Color:</p>
                                                        <RadioGroup value={selectedColor} onChange={setSelectedColor} className={`px-3 py-1.5 rounded-lg border-2 text-xs font-semibold transition-all ${val.color ? "border-violet-500 bg-violet-50 text-violet-700" : "border-gray-100 bg-gray-50 text-gray-600 hover:border-gray-300"}`}>
                                                            <RadioGroup.Label className="sr-only">Choose a color</RadioGroup.Label>
                                                            <div className="flex items-center space-x-3">
                                                                <span className="text-violet-700">{val.color}</span>
                                                                {/* <h4 className="text-sm/8 text-gray-900"> {val.color}</h4> */}
                                                                <div className="box-border size-1 border-4 p-1" style={{ backgroundColor: val.color }}>

                                                                </div>
                                                            </div>
                                                        </RadioGroup>
                                                        {/* <button onClick={() => setSelectedColor}
                        className={`px-3 py-1.5 rounded-lg border-2 text-xs font-semibold transition-all ${val.color ? "border-violet-500 bg-violet-50 text-violet-700" : "border-gray-100 bg-gray-50 text-gray-600 hover:border-gray-300"}`}
                      >{val.color}</button> */}

                                                    </div>
                                                </div>
                                                <p className="text-sm font-semibold text-gray-700 mb-2">{val.type}</p>
                                            </div>
                                            {/* Size variants */}

                                            <div className="mb-4">

                                                <div className="flex gap-2 flex-wrap">
                                                    <p className="text-sm font-semibold text-gray-700 mb-2">Size:  <span className="text-violet-700">{selectedSize}</span></p>
                                                    <RadioGroup value={selectedSize} onChange={setSelectedSize} className="text-start mt-1">
                                                        <RadioGroup.Label className="sr-only">Choose a size</RadioGroup.Label>
                                                        <div className="mr-2 grid grid-cols-2 gap-x-4 gap-y-4 sm:grid-cols-2">
                                                            {val.size.map((size, i) => (
                                                                <RadioGroup.Option
                                                                    key={i}
                                                                    value={size}
                                                                    disabled={false}
                                                                    className={({ active }) =>
                                                                        classNames(
                                                                            size.inStock
                                                                                ? 'cursor-pointer bg-white text-gray-900 shadow-sm'
                                                                                : 'w-32 cursor-pointer bg-gray-50 text-gray-500',
                                                                            active ? 'border-violet-500 bg-violet-50 text-violet-700' : '',
                                                                            'group relative flex items-center justify-center rounded-md border py-3 px-4 text-xs font-medium uppercase hover:bg-gray-50 focus:outline-none sm:flex-1'
                                                                        )
                                                                    }
                                                                >
                                                                    {({ active, checked }) => (
                                                                        <>
                                                                            <RadioGroup.Label as="span" style={{ lineBreak: "anywhere" }}>{size}</RadioGroup.Label>
                                                                            {size ? (
                                                                                <span
                                                                                    className={classNames(
                                                                                        active ? 'border' : 'border-2',
                                                                                        checked ? 'border-indigo-500' : 'border-transparent',
                                                                                        'pointer-events-auto absolute -inset-px rounded-md'
                                                                                    )}
                                                                                    aria-hidden="true"
                                                                                />
                                                                            ) : (
                                                                                <span
                                                                                    aria-hidden="true"
                                                                                    className="pointer-events-auto absolute -inset-px rounded-md border-2 border-gray-200"
                                                                                >
                                                                                    <svg
                                                                                        className="absolute inset-0 h-full w-full stroke-2 text-gray-200"
                                                                                        viewBox="0 0 100 100"
                                                                                        preserveAspectRatio="none"
                                                                                        stroke="currentColor"
                                                                                    >
                                                                                        <line x1={0} y1={100} x2={100} y2={0} vectorEffect="non-scaling-stroke" />
                                                                                    </svg>
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </RadioGroup.Option>
                                                            ))}
                                                        </div>
                                                    </RadioGroup>
                                                </div>
                                            </div>
                                            {/* Quantity */}
                                            <div className="flex items-center justify-between mb-4">
                                                <p className="text-sm font-semibold text-gray-700">Quantity</p>
                                                <div className="flex items-center gap-3">
                                                    <button onClick={() => decrement()} className="w-10 h-10 rounded-xl border-2 border-violet-100 bg-violet-50 text-violet-700 font-black text-lg hover:bg-violet-100 transition-colors flex items-center justify-center">−</button>
                                                    <span className="w-10 text-center font-poppins font-black text-xl text-gray-900">{quantity}</span>
                                                    <button onClick={() => increment()} className="w-10 h-10 rounded-xl bg-violet-700 text-white font-black text-lg hover:bg-violet-800 transition-colors flex items-center justify-center">+</button>
                                                </div>
                                                <span className="text-sm text-gray-600">
                                                    Only{" "}
                                                    <span className="text-orange-600 font-medium">
                                                        few items
                                                    </span>{" "}
                                                    remaining
                                                </span>
                                            </div>

                                            <Video height="48" url={val.videoUrl ? val.videoUrl : "https://www.youtube.com/embed/A51nvgt99Cc"} />

                                            <div className="grid grid-cols-1 flex-end mt-2 mb-2 text-left">
                                                <p className="text-md text-gray-900 font-bold"></p>
                                                <p className="text-xl text-gray-900 font-bold">Total(₹) : {(quantity * val.offer_prize).toLocaleString('en-US')}.00 /-</p>
                                                <p className='text-[12px] font-medium text-green-900'>Shopping/Offer calculated at (checkout)payment page</p>
                                            </div>
                                            <div className='h-auto'>
                                                {val.offer_prize > 999 && <div className="justify-between text-left p-1">
                                                    <p className="relative text-sm font-bold text-green-700">Final Price ₹{((quantity * val.offer_prize) - ((quantity * val.offer_prize) * (10 / 100)))} <span className='text-[9px]'>(If Coupon Applied On Direct Purchase)</span></p>
                                                </div>}
                                            </div>
                                            {/* CTA Buttons */}
                                            <div className="flex gap-3 mb-4">
                                                <button
                                                    onClick={() => onAddToCard({
                                                        name: val.brand,
                                                        product_name: val.product_name,
                                                        price: val.offer_prize,
                                                        real_prize: val.real_prize,
                                                        id: val.id,
                                                        freez: true,
                                                        count: quantity,
                                                        rating: 3.9,
                                                        reviewCount: 117,
                                                        imageSrc: val.url,
                                                        imageAlt: productReview,
                                                        colors: { name: val.color, class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
                                                        sizes: { name: selectedSize, inStock: true },
                                                        size: val.size,
                                                        uni_productId: val.uni_productId,
                                                        type: val.type,
                                                        detail: val.product_name + val.product_detail,
                                                        detail_url: val.detail_url,
                                                        delivery_charge: val.delivery_charge,
                                                        navItem: navItem,//navigation param
                                                        keywords: val.keywords,
                                                        ...(val.offer && { "offer": val.offer })
                                                    })}
                                                    disabled={val.freez}
                                                    className="flex-1 py-4 rounded-2xl font-poppins font-black text-sm border-2 transition-all border-violet-600 text-violet-700 hover:bg-violet-50"
                                                >
                                                    🛒 Add to Cart
                                                </button>
                                                <button
                                                    onClick={() => checkout([{
                                                        name: val.brand,
                                                        product_name: val.product_name,
                                                        price: val.offer_prize,
                                                        id: val.id,
                                                        count: quantity,
                                                        rating: 4.5,
                                                        reviewCount: 117,
                                                        imageSrc: val.url,
                                                        imageAlt: productReview,
                                                        colors: { name: selectedColor, class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
                                                        sizes: { name: selectedSize, inStock: true },
                                                        type: val.type,
                                                        detail: val.product_name,
                                                        delivery_charge: val.delivery_charge,
                                                        ...(val.offer && { "offer": val.offer })
                                                    }])}
                                                    disabled={val.freez}
                                                    className="flex-1 py-4 rounded-2xl font-poppins font-black text-sm bg-gradient-to-r from-orange-500 to-pink-600 text-white shadow-lg shadow-orange-200/50 hover:shadow-orange-300/60 transition-all active:scale-95"
                                                >
                                                    ⚡ Buy Now
                                                </button>
                                            </div>
                                            <button
                                                onClick={() => handleShare(val)}
                                                className="w-full flex items-center justify-center gap-2 bg-white text-gray-700 py-3 px-6 rounded-lg font-semibold border-2 border-gray-300 hover:bg-gray-50 transition-colors"
                                            >
                                                <ShareIcon className="h-5 w-5" />
                                                Share Product
                                            </button>
                                            <hr></hr>
                                            <p className="text-center text-xs text-gray-400">🔒 Secure Checkout · COD Available · 7-Day Returns</p>
                                            <div className="p-1 flex items-center justify-between">
                                                <a href="/privacy" className="text-sm font-medium text-indigo-600 hover:text-indigo-500">
                                                    Agree Policy
                                                </a>
                                                {/* <Sizeguard /> */}
                                            </div>
                                            {/* Delivery checker */}
                                            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
                                                <h3 className="font-poppins font-bold text-gray-900 mb-3 flex items-center gap-2">
                                                    <span>🚚</span> Delivery
                                                </h3>
                                                <div className="mt-3 grid grid-cols-3 gap-2 text-center">
                                                    {[
                                                        { icon: "📦", t: `Ships in`, s: "24 hours" },
                                                        { icon: "🚚", t: "Delivery", s: "2-5 DAYS" },
                                                        { icon: "↩️", t: "Returns", s: "7 days" },
                                                    ].map(i => (
                                                        <div key={i.t} className="bg-gray-50 rounded-xl p-2">
                                                            <span className="text-lg block">{i.icon}</span>
                                                            <p className="text-[10px] text-gray-500">{i.t}</p>
                                                            <p className="text-xs font-bold text-gray-800">{i.s}</p>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Product Highlights */}
                                            <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5">
                                                <h3 className="font-poppins font-bold text-gray-900 mb-3">Why You'll Love It</h3>
                                                {/* Product Description */}
                                                <div role="main">
                                                    <h3 className="font-poppins font-bold text-gray-900 mb-3">About This Product</h3>
                                                    <ul className="space-y-2 text-gray-600">
                                                        {splitToList(val.product_detail).map((feature, index) => (
                                                            <li key={index} className="flex leading-relaxed text-left">
                                                                <span className="w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0 mt-0.5"> <svg className="w-3 h-3 text-green-600" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg></span>
                                                                <p className="hero-desc" dangerouslySetInnerHTML={{ __html: feature }}></p>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </header>
                                    {/* <h3 className="text-xl bg-clip-text bg-gradient-to-r from-yellow-600 to-yellow-500 text-transparent  sm:pr-12 border-b"></h3> */}

                                    <section aria-labelledby="information-heading" className=" p-1">
                                        <h4 id="information-heading" className="sr-only">
                                            {val.product_name} {val.brand} {val.type}
                                        </h4>
                                        {/* <p className="flex-col m-2 bg-[#31C48D] px-2 text-center text-sm text-white">
                                            {val.offer ? val.offer : val.offer_prize > 1499 && "Free Delivery"}
                                        </p> */}


                                        <hr></hr>
                                        <div className="m-2 space-y-2">
                                            <section className="rounded about-section reveal p-2 " aria-labelledby="about-heading">
                                                <h4 id="about-heading" className="font-poppins font-bold text-gray-900 mb-3 flex items-center gap-2">Services</h4>
                                                {val.offer_prize > 999 && <TimeLeftUi />
                                                }
                                                {/* Trust strip */}

                                                <ul className="space-y-2 text-left text-sm text-gray-600">
                                                    <li key="0" className="flex leading-relaxed text-left space-x-4"> {val.delivery_charge == "00" ? <div className="flex">
                                                        <svg className="flex-shrink-0 w-6 h-6 text-indigo-600" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10 14.7875L13.0959 17.8834C13.3399 18.1274 13.7353 18.1275 13.9794 17.8838L20.625 11.25M15 27.5C8.09644 27.5 2.5 21.9036 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9036 2.5 27.5 8.09644 27.5 15C27.5 21.9036 21.9036 27.5 15 27.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                        <img width="48" height="48" src="https://img.icons8.com/external-flat-gradient-andi-nur-abdillah/64/external-delivery-delivery-and-logistic-flat-gradient-flat-gradient-andi-nur-abdillah-2.png" alt=" external-delivery-delivery-and-logistic-flat-gradient-flat-gradient-andi-nur-abdillah-2" className='animate-bounce' />
                                                        <p>Free delivery</p>
                                                    </div> : ""}</li>

                                                    <li className="flex leading-relaxed text-left space-x-4">

                                                        <svg className="flex-shrink-0 w-6 h-6 text-indigo-600" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10 14.7875L13.0959 17.8834C13.3399 18.1274 13.7353 18.1275 13.9794 17.8838L20.625 11.25M15 27.5C8.09644 27.5 2.5 21.9036 2.5 15C2.5 8.09644 8.09644 2.5 15 2.5C21.9036 2.5 27.5 8.09644 27.5 15C27.5 21.9036 21.9036 27.5 15 27.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                        <span>Need help ! Contact us on mail@triokzz.com</span>
                                                    </li>
                                                    <li className="flex leading-relaxed text-left space-x-4">
                                                        <img
                                                            className="h-10 w-60"
                                                            src={PaymentOptions}
                                                            // width="100%" height="100%"
                                                            alt="Paithani, grocery, skin care, shankara naturals, amazo, Solid T-shirt,Plain T-Shirt,Buy Plain Solid T-shirts,printo mug, Bewakoofy items, home decor items, sculptures, inspiring, large luggage bags, popular duffle, touring bags, big size travel bags online, purse, wholesale mugs, custom cups and mugs, ceramic printed mugs, copper drinking mugs, cups for camping, purses for women, purse sale, branded bags for women, multi pocket bags"
                                                        />
                                                        {/* <span>Pay With UPI, Cash On Delivery, Cards, Upi, Net Banking, EMI</span> */}
                                                    </li>
                                                    <li className="flex leading-relaxed text-left space-x-4">
                                                        <div className="flex space-x-2" onClick={() => window.location.replace(`https://play.google.com/store/apps/details?id=com.triokzz.app`)}>
                                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-v52tLnvL3FEjfxjPvZWbvUMYvVUtAm9R6A&s" alt="Google Play" className="w-24 h-10" width="100%" height="100%" />
                                                            {/* <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJgk5tpxJC_1CAnsXwo2VvBGyQGI-o5c1PJw&s" alt="App Store" className="h-10"/> */}
                                                        </div>
                                                    </li>

                                                    <li className="flex leading-relaxed text-left space-x-4">
                                                        <div className="flex space-x-2 md:mt-0">
                                                            <img src="https://www.logo.wine/a/logo/Apple_Pay/Apple_Pay-White-Dark-Background-Logo.wine.svg" alt="Apple Pay" className="h-[30px] w-10 rounded-md" width="100%" height="100%" />
                                                            {/* <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSynWEtLag--sQ4XlfTwHh9_DAnfcglW7C3iw&s" alt="Visa" className="h-[30px] w-10 rounded-md" width="100%" height="100%" /> */}
                                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6mJsEDg1aR_JCFb3ohk2nCxjgSvkWnpmlKg&s" alt="Mastercard" className="h-[30px] w-10 rounded-md" width="100%" height="100%" />
                                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQveKfGcJ1tSEY8bLg52DxvVrFDJXmxXJgv1Q&s" alt="discover" className="h-[30px] w-10 rounded-md" width="100%" height="100%" />
                                                            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDS0zyuJdI4e7E1VGaNDAVtRn3fGTzr0PBOA&s" alt="Secure Payment" className="h-[30px] w-10 rounded-md" width="100%" height="100%" />
                                                        </div>

                                                    </li>
                                                </ul>
                                            </section>

                                            <div
                                                className="group flex flex-col rounded-lg bg-black p-2 text-white"
                                                tabIndex="1"
                                            >
                                                <div className="flex cursor-pointer items-center justify-between">
                                                    <h2> Rating </h2>
                                                    <img
                                                        src="https://upload.wikimedia.org/wikipedia/commons/9/96/Chevron-icon-drop-down-menu-WHITE.png"
                                                        className="h-2 w-3 transition-all duration-500 group-focus:-rotate-180"
                                                        width="1200"
                                                        height="800"
                                                        alt="dropdown"
                                                    />
                                                </div>
                                                <div
                                                    className="invisible h-auto max-h-0 items-center opacity-0 transition-all group-focus:visible group-focus:max-h-screen group-focus:opacity-100 group-focus:duration-1000"
                                                >
                                                    {/* Reviews */}
                                                    <div className="mt-6 mb-6">
                                                        <h4 className="sr-only">Reviews</h4>
                                                        <div className="flex items-center">
                                                            <a href="https://g.page/r/CYWYfi5lwEcbEBM/review" className="flex">
                                                                <div className="flex items-center">
                                                                    {count.map((rating, index) => (
                                                                        <StarIcon
                                                                            key={index}
                                                                            className={classNames(
                                                                                val.rating > rating ? 'text-yellow-900' : 'text-gray-200',
                                                                                'h-5 w-5 flex-shrink-0'
                                                                            )}
                                                                            aria-hidden="true"
                                                                            onClick={() => setarr(new Array(rating + 1).fill(null).map((_, i) => i))}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </a>
                                                            <p className="sr-only">{val.rating} out of 5 stars</p>
                                                            <a href="https://g.page/r/CYWYfi5lwEcbEBM/review" className="ml-3 text-sm font-medium text-white-600 hover:text-indigo-500">
                                                                {val.rating} Rating
                                                            </a>
                                                        </div>
                                                        {/* rating bar  */}
                                                        <div className="flex items-center mt-4">
                                                            <div className="text-sm font-medium text-blue-600 dark:text-blue-500 hover:underline">5 star</div>
                                                            <div className="w-2/4 h-5 mx-4 bg-white rounded dark:bg-gray-700">
                                                                <div className="h-5 bg-yellow-300 rounded" style={{ width: "70%" }}></div>
                                                            </div>
                                                            <span className="text-sm font-medium text-white dark:text-gray-400">70%</span>
                                                        </div>
                                                        <div className="flex items-center mt-4">
                                                            <div className="text-sm font-medium text-blue-600 dark:text-blue-500 hover:underline">4 star</div>
                                                            <div className="w-2/4 h-5 mx-4 bg-white rounded dark:bg-gray-700">
                                                                <div className="h-5 bg-yellow-300 rounded" style={{ width: "60%" }}></div>
                                                            </div>
                                                            <span className="text-sm font-medium text-white dark:text-gray-400">60%</span>
                                                        </div>
                                                        <div className="flex items-center mt-4">
                                                            <div className="text-sm font-medium text-blue-600 dark:text-blue-500 hover:underline">3 star</div>
                                                            <div className="w-2/4 h-5 mx-4 bg-white rounded dark:bg-gray-700">
                                                                <div className="h-5 bg-yellow-300 rounded" style={{ width: "8%" }}></div>
                                                            </div>
                                                            <span className="text-sm font-medium text-white dark:text-gray-400">8%</span>
                                                        </div>
                                                        <div className="flex items-center mt-4">
                                                            <div className="text-sm font-medium text-blue-600 dark:text-blue-500 hover:underline">2 star</div>
                                                            <div className="w-2/4 h-5 mx-4 bg-white rounded dark:bg-gray-700">
                                                                <div className="h-5 bg-yellow-300 rounded" style={{ width: "4%" }}></div>
                                                            </div>
                                                            <span className="text-sm font-medium text-white dark:text-gray-400">4%</span>
                                                        </div>
                                                        <div className="flex items-center mt-4">
                                                            <div className="text-sm font-medium text-blue-600 dark:text-blue-500 hover:underline">1 star</div>
                                                            <div className="w-2/4 h-5 mx-4 bg-white rounded dark:bg-gray-700">
                                                                <div className="h-5 bg-yellow-300 rounded" style={{ width: "4%" }}></div>
                                                            </div>
                                                            <span className="text-sm font-medium text-white dark:text-gray-400">1%</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Social proof */}
                                            <div className="bg-violet-50 rounded-2xl border border-violet-100 p-4">
                                                <p className="text-xs font-bold text-violet-800 mb-2">⭐ Loved by 20,000+ customers</p>
                                                {[
                                                    { name: "Sunita M.", loc: "Mumbai", text: "Super fast delivery! Quality was amazing." },
                                                    { name: "Rahul K.", loc: "Delhi", text: "Authentic products, exactly as described." },
                                                ].map(r => (
                                                    <div key={r.name} className="bg-white rounded-xl p-3 mb-2 last:mb-0">
                                                        <div className="flex items-center gap-1.5 mb-1">
                                                            <span className="text-xs font-bold text-gray-700">{r.name}</span>
                                                            <span className="text-[10px] text-gray-400">· {r.loc}</span>
                                                            <span className="ml-auto text-amber-400 text-xs">★★★★★</span>
                                                        </div>
                                                        <p className="text-[11px] text-gray-500">{r.text}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>


                                        {/* bottom-32 */}
                                        <div id="bottom-navigation" className='block fixed inset-x-0 bottom-0 z-10 bg-white shadow p-4 pb-5 border border-slate-300'>
                                            <div className="flex">

                                                <div className="flex-shrink-0 text-xs font-medium text-gray-900">
                                                    <OptimizedImage src={val.url} className="w-16 h-16" />
                                                </div>
                                                <div className="ml-4 flex flex-1 flex-col">
                                                    <div>
                                                        <div className="text-xs float-left font-medium text-gray-900">
                                                            <h3 className="text-xs font-semibold text-gray-800 line-clamp-1 mb-1.5">
                                                                {val.product_name}
                                                            </h3>
                                                        </div>

                                                    </div>
                                                    <div>
                                                        {/* <span className="font-medium mb-3 block text-left">Quantity</span> */}

                                                        <div className="flex items-center gap-1">
                                                            <div className="flex items-center border-2 border-gray-200 rounded-lg">
                                                                <button
                                                                    onClick={() => decrement()}
                                                                    className="px-4 py-1 hover:bg-gray-100 transition-colors"
                                                                >
                                                                    -
                                                                </button>
                                                                <span className=" border-x-2 border-gray-200">
                                                                    {quantity}
                                                                </span>
                                                                <button
                                                                    onClick={() => increment()}
                                                                    className="px-4 py-1 hover:bg-gray-100 transition-colors"
                                                                >
                                                                    +
                                                                </button>
                                                            </div>
                                                            <div className='Cols'>
                                                                <p className="text-xs font-bold">₹{(quantity * val.offer_prize).toLocaleString('en-US')}.00</p>
                                                                <p className=" text-xs text-gray-400 line-through">₹{(val.real_prize).toLocaleString('en-US')}.00</p>
                                                            </div>
                                                            <div className='Cols'>
                                                                {!val.offer ? <span className='bg-green-100 text-black-600 text-xs font-medium mr-2 px-1.5 py-1 rounded-full'>
                                                                    {Math.round(
                                                                        ((val.real_prize - val.offer_prize) / val.real_prize) * 100,
                                                                    )}
                                                                    % OFF
                                                                </span> :
                                                                    <span className='bg-green-100 text-black-600 text-xs font-medium  rounded-full'>
                                                                        Add {val.offer}
                                                                    </span>}
                                                            </div>


                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            <div className='flex'>
                                                {!val.freez ? <div className="relative mt-2 w-full flex items-center justify-center transition" onClick={() => onAddToCard({
                                                    name: val.brand,
                                                    product_name: val.product_name,
                                                    price: val.offer_prize,
                                                    real_prize: val.real_prize,
                                                    id: val.id,
                                                    freez: true,
                                                    count: quantity,
                                                    rating: 3.9,
                                                    reviewCount: 117,
                                                    imageSrc: val.url,
                                                    imageAlt: productReview,
                                                    colors: { name: val.color, class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
                                                    sizes: { name: selectedSize, inStock: true },
                                                    size: val.size,
                                                    uni_productId: val.uni_productId,
                                                    type: val.type,
                                                    detail: val.product_name + val.product_detail,
                                                    detail_url: val.detail_url,
                                                    delivery_charge: val.delivery_charge,
                                                    navItem: navItem,//navigation param
                                                    keywords: val.keywords,
                                                    ...(val.offer && { "offer": val.offer })
                                                })}>
                                                    <div
                                                        className="flex-1 py-4 rounded-2xl font-poppins font-black text-sm border-2 transition-all border-violet-600 text-violet-700 hover:bg-violet-50"
                                                    >
                                                        Add to Cart 🛒
                                                    </div>

                                                </div> : <div className="relative p-1 flex tems-center justify-center">
                                                    <div
                                                        className="flex w-full item-center justify-center rounded-md border border border-indigo-300 bg-red-600 text-white px-1 py-1 text-base font-small shadow-sm hover:bg-indigo-700"
                                                    >
                                                        Not Available
                                                    </div>

                                                </div>}

                                                <div className="relative mt-2 w-full flex items-center justify-center transition" onClick={() => checkout([{
                                                    name: val.brand,
                                                    product_name: val.product_name,
                                                    price: val.offer_prize,
                                                    id: val.id,
                                                    count: quantity,
                                                    rating: 4.5,
                                                    reviewCount: 117,
                                                    imageSrc: val.url,
                                                    imageAlt: productReview,
                                                    colors: { name: selectedColor, class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
                                                    sizes: { name: selectedSize, inStock: true },
                                                    type: val.type,
                                                    detail: val.product_name,
                                                    delivery_charge: val.delivery_charge,
                                                    ...(val.offer && { "offer": val.offer })
                                                }])}>
                                                    <button
                                                        // type="submit"
                                                        className="flex-1 py-4 rounded-2xl font-poppins font-black text-sm bg-gradient-to-r from-orange-500 to-pink-600 text-white shadow-lg shadow-orange-200/50 hover:shadow-orange-300/60 transition-all active:scale-95"
                                                    >
                                                        Buy Now
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <label htmlFor="product_review" className="block text-sm font-medium leading-6 text-gray-900"><h3 className='font-bold'>Review this product</h3>
                                                Share your thoughts with other customers
                                            </label>
                                            <div className="mt-2">
                                                <textarea id="product_review" value={productReview} onChange={(e) => setProductReview(e.target.value)} rows="4" name="product_review" type="text" autoComplete="product_review" placeholder="Product Review/feedback !" required className="block w-full rounded-md border-1 py-1.5 px-2  text-gray-500 shadow-sm ring-1 ring-inset ring-black placeholder:text-black focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                                            </div>
                                        </div>
                                        {/* <GoogleReviews placeId="ChIJa1IpjXdKaIMRhZh-LmXARxs" /> */}
                                        {/* <img className="flex md:w-auto p-2" src={CcavenuePayment} width="100%" height="100%" alt="ccavenue"></img> */}


                                        <section aria-labelledby="options-heading" className="mt-1">
                                            {val.keywords.map((value, i) => <h3 key={i} id="information-heading" className="sr-only">
                                                {value}
                                            </h3>)}
                                        </section>
                                    </section>
                                    <div>
                                        <h2 className="font-poppins font-bold text-xl text-gray-900 mb-4">Similar Products You May Like</h2>
                                        <p className="text-sm text-gray-500 mt-0.5">
                                            Curated picks from verified artisans
                                        </p>
                                    </div>
                                    <ul className="mt-8 grid grid-cols-2  sm:grid-cols-2 xl:grid-cols-6 lg:grid-cols-6 md:grid-cols-4 items-center justify-center gap-1 border text-start leading-2">
                                        {relevantProduct && relevantProduct.map((value, index) => {
                                            return (
                                                <li key={index} className={value.freez ? "group relative border border-gray-200 shadow-2xs pointer-events-none transformed opacity-40 bg-white" : "group relative card-hover bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm cursor-pointer"}>
                                                    <a href={`/amazing-product/${navItem}/${value.type}${value.id}`} >
                                                        {/* <img src={value.url} alt={value.product_name} className="aspect-square bg-gray-100 rounded-lg flex items-center justify-center overflow-hidden" title={value.product_name} width="100%" height="100%" /> */}
                                                        <div className="rounded-lg flex items-center justify-center overflow-hidden"
                                                        //  style={{ backgroundImage: `url(${val.url})`, backgroundSize: "cover", backgroundPosition: "center", backg: "blur(8px)" }}
                                                        >
                                                            <div className='w-64 h-64 justify-items-center bg-[ #F5F5F5]'>
                                                                <OptimizedImage
                                                                    src={value.url}
                                                                    loading="lazy"
                                                                    alt={value.type}
                                                                    // width="600"
                                                                    // height="400"
                                                                    className={`image-[rendering:pixelated] hero-image w-full h-full ${item == "womens" ? "" : "object-cover"}`}
                                                                    // className={`aspect-square image-[rendering:pixelated] onject-contain group-hover:scale-105 transition-transform duration-300 rounded-[20px]`}
                                                                    title={value.product_name}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center ">
                                                            <span className='bg-green-100 text-emerald-600 text-xs font-medium px-1 py-1 rounded-full text-[8px]'>In Stock</span>
                                                            <span className="bg-green-100 text-emerald-600 text-xs font-medium px-1 py-1 rounded-full">
                                                                {value.offer ? value.offer : "Free Delivery"}
                                                            </span>
                                                        </div>
                                                        {/* <span className="absolute top-0 left-0 m-1 px-2 text-center text-xs italic font-bold bg-gradient-to-r from-blue-100 to-blue-500 text-red-700 animate-[fade-in-bounce-left_3s_ease-in-out]">{value.offer ? value.offer : value.offer_prize > 1499 && <div className='flex justify-between'><span>Free Delivery  </span> <img width="20" height="48" src="https://img.icons8.com/external-flat-gradient-andi-nur-abdillah/64/external-delivery-delivery-and-logistic-flat-gradient-flat-gradient-andi-nur-abdillah-2.png" alt=" external-delivery-delivery-and-logistic-flat-gradient-flat-gradient-andi-nur-abdillah-2" className='animate-[fade-in-bounce-left_10s_ease-in-out_infinite]' /></div>
                                                        }</span> */}
                                                        <div className="grid grid-cols-1 justify-between text-start">
                                                            <div className="h-12 p-1 justify-between"
                                                            //  onClick={() => onOpen(val)}
                                                            >
                                                                <h3 className="text-xs font-semibold text-gray-800 line-clamp-2 mb-1.5">
                                                                    {value.product_name}
                                                                </h3>
                                                                <p className="sr-only"><span>
                                                                    {value.product_detail}
                                                                </span> </p>
                                                            </div>
                                                        </div>
                                                        <div className="flex items-center gap-1.5">
                                                            <svg className="w-4 h-4 text-yellow-300 me-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 22 20">
                                                                <path d="M20.924 7.625a1.523 1.523 0 0 0-1.238-1.044l-5.051-.734-2.259-4.577a1.534 1.534 0 0 0-2.752 0L7.365 5.847l-5.051.734A1.535 1.535 0 0 0 1.463 9.2l3.656 3.563-.863 5.031a1.532 1.532 0 0 0 2.226 1.616L11 17.033l4.518 2.375a1.534 1.534 0 0 0 2.226-1.617l-.863-5.03L20.537 9.2a1.523 1.523 0 0 0 .387-1.575Z" />
                                                            </svg>
                                                            <span className="text-xs text-gray-500">
                                                                ({value.rating.toLocaleString()})
                                                            </span>
                                                        </div>

                                                        <div className="flex items-center gap-2">
                                                            <span className="font-poppins font-bold text-gray-900 text-lg">
                                                                ₹{value.offer_prize.toLocaleString()}
                                                            </span>
                                                            <span className="text-gray-400 text-sm line-through">
                                                                ₹{value.real_prize.toLocaleString()}
                                                            </span>
                                                            <span className="text-green-600 text-xs font-bold">
                                                                {Math.floor(Math.abs(((value.offer_prize - value.real_prize) / value.real_prize) * 100))}% off
                                                            </span>
                                                        </div>
                                                        {value.offer_prize > 999 && <div className='h-6'>
                                                            <div className="justify-between text-start p-1">
                                                                <p className="relative text-[8px] font-bold text-green-700">Final Price ₹{(value.offer_prize - (value.offer_prize * (10 / 100)))} <span className='text-[8px]'>(If Coupon Applied On Direct Purchase)</span></p>
                                                            </div>
                                                        </div>}
                                                    </a>
                                                    <div className=" grid grid-cols-1 text-center justify-between drop-shadow-lg" >

                                                        {!value.freez ? <div className="relative p-1 flex tems-center justify-center hover:scale-125 transition" onClick={() => onAddToCard({
                                                            name: value.brand,
                                                            product_name: value.product_name,
                                                            price: value.offer_prize,
                                                            real_prize: value.real_prize,
                                                            id: value.id,
                                                            freez: true,
                                                            count: value.count,
                                                            rating: 3.9,
                                                            reviewCount: 117,
                                                            imageSrc: value.url,
                                                            imageAlt: productReview,
                                                            colors: { name: value.color, class: 'bg-gray-900', selectedClass: 'ring-gray-900' },
                                                            sizes: { name: value.size[0], inStock: true },
                                                            size: value.size,
                                                            uni_productId: value.uni_productId,
                                                            type: value.type,
                                                            navItem: navItem,//navigation param
                                                            detail: value.product_name + value.product_detail,
                                                            detail_url: value.detail_url,
                                                            delivery_charge: value.delivery_charge,
                                                            ...(value.offer && { "offer": value.offer })
                                                        })}>
                                                            <div
                                                                className="w-full bg-gradient-to-r from-violet-600 to-purple-700 hover:from-violet-700 hover:to-purple-800 text-white text-sm font-poppins font-semibold py-2.5 rounded-xl transition-all pulse-cta"
                                                            >
                                                                Add to Cart   🛒
                                                            </div>

                                                        </div> : <div className="relative p-1 flex tems-center justify-center">
                                                            <div
                                                                className="flex w-3/4 item-center justify-center rounded-md border border border-indigo-300 bg-red-600 text-white px-1 py-1 text-base font-small shadow-sm hover:bg-indigo-700"
                                                            >
                                                                Not Available
                                                            </div>

                                                        </div>}
                                                    </div>
                                                </li>
                                            )
                                        })
                                        }
                                    </ul>
                                    <hr></hr>

                                </div>
                            </div>
                        </div>}

                    </div>
                )
            }) : <div role="status" className="max-w-sm p-4 border border-gray-200 rounded shadow animate-pulse md:p-6 dark:border-gray-700">
                <div className="flex items-center justify-center h-48 mb-4 bg-gray-300 rounded dark:bg-gray-700">
                    <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                        <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                        <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                    </svg>
                    <img src={Logo} alt="customised triokz style"></img>
                </div>
                <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
                <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div className="flex items-center mt-4">
                    <svg className="w-10 h-10 me-3 text-gray-200 dark:text-gray-700" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
                    </svg>
                    <div>
                        <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2"></div>
                        <div className="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                    </div>
                </div>
                <span className="">Loading...</span>
            </div>}
            {chattoggle && <div id="chat-container" className="z-20 fixed bottom-16 right-4 w-86">
                <div className="bg-white shadow-md rounded-lg max-w-lg w-full">
                    <Chatbot id="chatbox" className="p-4 h-80 overflow-y-auto" steps={steps} />
                </div>
            </div>}
            <section className="bg-gradient-to-br from-violet-900 to-purple-800 rounded-2xl p-8 text-white">
                <h2 className="font-poppins font-black text-2xl sm:text-3xl text-center mb-2">
                    What Makes Triokzz Different?
                </h2>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                    {[
                        {
                            icon: "🤝",
                            title: "Fair Artisan Pay",
                            desc: "Every craftsperson earns above industry average. Your purchase directly supports their livelihood.",
                        },
                        {
                            icon: "🌿",
                            title: "Ethically Sourced",
                            desc: "Raw materials are sustainably sourced and cruelty-free. We audit our supply chain annually.",
                        },
                        {
                            icon: "✨",
                            title: "Handcrafted Quality",
                            desc: "Each piece is made by hand, inspected by experts, and packed with care before shipping.",
                        },
                    ].map((item) => (
                        <div
                            key={item.title}
                            className="bg-white/10 backdrop-blur rounded-xl p-5 text-center hover:bg-white/20 transition-colors"
                        >
                            <span className="text-4xl block mb-3">{item.icon}</span>
                            <h3 className="font-poppins font-bold text-lg mb-2">
                                {item.title}
                            </h3>
                            <p className="text-violet-200 text-sm leading-relaxed">
                                {item.desc}
                            </p>
                        </div>
                    ))}
                </div>
            </section>
            <section className="bg-white rounded-2xl border border-gray-100 p-6 shadow-sm">
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
                    {[
                        { value: "10,000+", label: "Happy Customers", icon: "😊" },
                        { value: "4.8★", label: "Average Rating", icon: "⭐" },
                        { value: "12+", label: "Artisan Partners", icon: "🎨" },
                        { value: "₹2 L+", label: "Artisan Earnings", icon: "💰" },
                    ].map((stat) => (
                        <div key={stat.label}>
                            <span className="text-2xl block mb-1">{stat.icon}</span>
                            <p className="font-poppins font-black text-2xl text-violet-700">
                                {stat.value}
                            </p>
                            <p className="text-xs text-gray-500 font-medium mt-0.5">
                                {stat.label}
                            </p>
                        </div>
                    ))}
                </div>
            </section>
            <footer className=" relative 
             inset-x-0 bottom-0 bg-gray-900 rounded-lg shadow dark:bg-gray-900 m-2 pb-16" role="contentinfo">
                <div className="w-full max-w-screen-xl mx-auto p-4 md:py-8">
                    <div className="sm:flex sm:items-center sm:justify-between">
                        <a href="#" className="flex items-center mb-4 sm:mb-0">
                            <img src={Logo} className="h-14 w-25 mr-3" alt="shoppp Logo" title="triokzz" />
                            <span className="sr-only">Save your amazing power looks items, Healthy products only on triokzz. flip to cart and get millets, dairy products, healthy snacks and more at one place -Triokzz, JiGari, Ted baker, fasion</span>
                        </a>
                    </div>

                    <div className="sm:flex sm:items-center sm:justify-between">
                        <a href="#" className="flex items-center mb-4 sm:mb-0 text-white">
                            Catalogue
                        </a>
                        <ul className="flex flex-wrap items-center mb-6 text-sm font-medium text-white sm:mb-0 dark:text-white">
                            <li className="mr-4 hover:underline md:mr-6 " onClick={() => navigate("/product/printed")}>
                                Ceramic World
                            </li>
                            <li className="mr-4 hover:underline md:mr-6 " onClick={() => navigate("/product/decor")}>
                                Home Decor
                            </li>
                            <li className="mr-4 hover:underline md:mr-6 " onClick={() => navigate("/product/womens")}>
                                Womens Traditional Wear
                            </li>
                            <li className="mr-4 hover:underline md:mr-6 " onClick={() => navigate("/product/skincare-cosmetics")}>
                                Skin Care Products
                            </li>
                            <li className="mr-4 hover:underline md:mr-6" onClick={() => navigate("/product/travelling")}>
                                Bags
                            </li>
                            <li className="mr-4 hover:underline md:mr-6 ">
                                <a href="/contact" className="hover:underline">{navItem}</a>
                            </li>
                            <li className="mr-4 hover:underline md:mr-6 ">
                                <a href="/contact" className="hover:underline">Contact Us</a>
                            </li>
                            <li className="mr-4 hover:underline md:mr-6 ">
                                <a href="/privacy" className="hover:underline">Return Policy </a>
                            </li>
                        </ul>
                    </div>

                    <hr className="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />

                    <div className="sm:flex sm:items-center sm:justify-between mb-24">
                        <span className="block text-sm text-white sm:text-center dark:text-gray-400">from © 2023 Developed By <a href="https://www.triokzz.com/contact" className="hover:underline">Triokzz</a>. All Rights Reserved.</span>
                        <div className="flex mt-4 space-x-2 sm:justify-center sm:mt-0">

                            <a href="https://www.facebook.com/profile.php?id=61553460826080&mibexid=ZbWKwL" className="w-12 h-12 flex items-center justify-center bg-gradient-to-tr from-red-50 to-pink-50 cursor-pointer rounded-md shadow-md shadow-transparent transition-all duration-300 hover:shadow-red-200" role="button">
                                <svg className="" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 92 92" fill="none">
                                    <rect x="0.138672" rx="15" fill="#EDF4FF" />
                                    <path d="M56.4927 48.6403L57.7973 40.3588H49.7611V34.9759C49.7611 32.7114 50.883 30.4987 54.4706 30.4987H58.1756V23.4465C56.018 23.1028 53.8378 22.9168 51.6527 22.8901C45.0385 22.8901 40.7204 26.8626 40.7204 34.0442V40.3588H33.3887V48.6403H40.7204V68.671H49.7611V48.6403H56.4927Z" fill="#337FFF" />
                                </svg>
                            </a>

                            <a href="https://www.instagram.com/triokzz?igsh=MWUzM3dweTNyY2NpeA==" className="w-12 h-12 flex items-center justify-center bg-gradient-to-tr from-red-50 to-pink-50 cursor-pointer rounded-md shadow-md shadow-transparent transition-all duration-300 hover:shadow-red-200" role="button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 51 51" fill="none">
                                    <path d="M17.4456 25.7808C17.4456 21.1786 21.1776 17.4468 25.7826 17.4468C30.3875 17.4468 34.1216 21.1786 34.1216 25.7808C34.1216 30.383 30.3875 34.1148 25.7826 34.1148C21.1776 34.1148 17.4456 30.383 17.4456 25.7808ZM12.9377 25.7808C12.9377 32.8708 18.6883 38.618 25.7826 38.618C32.8768 38.618 38.6275 32.8708 38.6275 25.7808C38.6275 18.6908 32.8768 12.9436 25.7826 12.9436C18.6883 12.9436 12.9377 18.6908 12.9377 25.7808ZM36.1342 12.4346C36.1339 13.0279 36.3098 13.608 36.6394 14.1015C36.9691 14.595 37.4377 14.9797 37.9861 15.2069C38.5346 15.4342 39.1381 15.4939 39.7204 15.3784C40.3028 15.2628 40.8378 14.9773 41.2577 14.5579C41.6777 14.1385 41.9638 13.6041 42.0799 13.0222C42.1959 12.4403 42.1367 11.8371 41.9097 11.2888C41.6828 10.7406 41.2982 10.2719 40.8047 9.94202C40.3112 9.61218 39.7309 9.436 39.1372 9.43576H39.136C38.3402 9.43613 37.5771 9.75216 37.0142 10.3144C36.4514 10.8767 36.1349 11.6392 36.1342 12.4346ZM15.6765 46.1302C13.2377 46.0192 11.9121 45.6132 11.0311 45.2702C9.86323 44.8158 9.02993 44.2746 8.15381 43.4002C7.27768 42.5258 6.73536 41.6938 6.28269 40.5266C5.93928 39.6466 5.53304 38.3214 5.42217 35.884C5.3009 33.2488 5.27668 32.4572 5.27668 25.781C5.27668 19.1048 5.3029 18.3154 5.42217 15.678C5.53324 13.2406 5.94248 11.918 6.28269 11.0354C6.73736 9.86816 7.27888 9.03536 8.15381 8.15976C9.02873 7.28416 9.86123 6.74216 11.0311 6.28976C11.9117 5.94656 13.2377 5.54056 15.6765 5.42976C18.3133 5.30856 19.1054 5.28436 25.7826 5.28436C32.4598 5.28436 33.2527 5.31056 35.8916 5.42976C38.3305 5.54076 39.6539 5.94976 40.537 6.28976C41.7049 6.74216 42.5382 7.28536 43.4144 8.15976C44.2905 9.03416 44.8308 9.86816 45.2855 11.0354C45.6289 11.9154 46.0351 13.2406 46.146 15.678C46.2673 18.3154 46.2915 19.1048 46.2915 25.781C46.2915 32.4572 46.2673 33.2466 46.146 35.884C46.0349 38.3214 45.6267 39.6462 45.2855 40.5266C44.8308 41.6938 44.2893 42.5266 43.4144 43.4002C42.5394 44.2738 41.7049 44.8158 40.537 45.2702C39.6565 45.6134 38.3305 46.0194 35.8916 46.1302C33.2549 46.2514 32.4628 46.2756 25.7826 46.2756C19.1024 46.2756 18.3125 46.2514 15.6765 46.1302ZM15.4694 0.932162C12.8064 1.05336 10.9867 1.47536 9.39755 2.09336C7.75177 2.73156 6.35853 3.58776 4.9663 4.97696C3.57406 6.36616 2.71955 7.76076 2.08097 9.40556C1.46259 10.9948 1.04034 12.8124 0.919069 15.4738C0.795795 18.1394 0.767578 18.9916 0.767578 25.7808C0.767578 32.57 0.795795 33.4222 0.919069 36.0878C1.04034 38.7494 1.46259 40.5668 2.08097 42.156C2.71955 43.7998 3.57426 45.196 4.9663 46.5846C6.35833 47.9732 7.75177 48.8282 9.39755 49.4682C10.9897 50.0862 12.8064 50.5082 15.4694 50.6294C18.138 50.7506 18.9893 50.7808 25.7826 50.7808C32.5759 50.7808 33.4286 50.7526 36.0958 50.6294C38.759 50.5082 40.5774 50.0862 42.1676 49.4682C43.8124 48.8282 45.2066 47.9738 46.5989 46.5846C47.9911 45.1954 48.8438 43.7998 49.4842 42.156C50.1026 40.5668 50.5268 38.7492 50.6461 36.0878C50.7674 33.4202 50.7956 32.57 50.7956 25.7808C50.7956 18.9916 50.7674 18.1394 50.6461 15.4738C50.5248 12.8122 50.1026 10.9938 49.4842 9.40556C48.8438 7.76176 47.9889 6.36836 46.5989 4.97696C45.2088 3.58556 43.8124 2.73156 42.1696 2.09336C40.5775 1.47536 38.7588 1.05136 36.0978 0.932162C33.4306 0.810962 32.5779 0.780762 25.7846 0.780762C18.9913 0.780762 18.138 0.808962 15.4694 0.932162Z" fill="url(#paint0_radial_7092_54379)" />
                                    <path d="M17.4456 25.7808C17.4456 21.1786 21.1776 17.4468 25.7826 17.4468C30.3875 17.4468 34.1216 21.1786 34.1216 25.7808C34.1216 30.383 30.3875 34.1148 25.7826 34.1148C21.1776 34.1148 17.4456 30.383 17.4456 25.7808ZM12.9377 25.7808C12.9377 32.8708 18.6883 38.618 25.7826 38.618C32.8768 38.618 38.6275 32.8708 38.6275 25.7808C38.6275 18.6908 32.8768 12.9436 25.7826 12.9436C18.6883 12.9436 12.9377 18.6908 12.9377 25.7808ZM36.1342 12.4346C36.1339 13.0279 36.3098 13.608 36.6394 14.1015C36.9691 14.595 37.4377 14.9797 37.9861 15.2069C38.5346 15.4342 39.1381 15.4939 39.7204 15.3784C40.3028 15.2628 40.8378 14.9773 41.2577 14.5579C41.6777 14.1385 41.9638 13.6041 42.0799 13.0222C42.1959 12.4403 42.1367 11.8371 41.9097 11.2888C41.6828 10.7406 41.2982 10.2719 40.8047 9.94202C40.3112 9.61218 39.7309 9.436 39.1372 9.43576H39.136C38.3402 9.43613 37.5771 9.75216 37.0142 10.3144C36.4514 10.8767 36.1349 11.6392 36.1342 12.4346ZM15.6765 46.1302C13.2377 46.0192 11.9121 45.6132 11.0311 45.2702C9.86323 44.8158 9.02993 44.2746 8.15381 43.4002C7.27768 42.5258 6.73536 41.6938 6.28269 40.5266C5.93928 39.6466 5.53304 38.3214 5.42217 35.884C5.3009 33.2488 5.27668 32.4572 5.27668 25.781C5.27668 19.1048 5.3029 18.3154 5.42217 15.678C5.53324 13.2406 5.94248 11.918 6.28269 11.0354C6.73736 9.86816 7.27888 9.03536 8.15381 8.15976C9.02873 7.28416 9.86123 6.74216 11.0311 6.28976C11.9117 5.94656 13.2377 5.54056 15.6765 5.42976C18.3133 5.30856 19.1054 5.28436 25.7826 5.28436C32.4598 5.28436 33.2527 5.31056 35.8916 5.42976C38.3305 5.54076 39.6539 5.94976 40.537 6.28976C41.7049 6.74216 42.5382 7.28536 43.4144 8.15976C44.2905 9.03416 44.8308 9.86816 45.2855 11.0354C45.6289 11.9154 46.0351 13.2406 46.146 15.678C46.2673 18.3154 46.2915 19.1048 46.2915 25.781C46.2915 32.4572 46.2673 33.2466 46.146 35.884C46.0349 38.3214 45.6267 39.6462 45.2855 40.5266C44.8308 41.6938 44.2893 42.5266 43.4144 43.4002C42.5394 44.2738 41.7049 44.8158 40.537 45.2702C39.6565 45.6134 38.3305 46.0194 35.8916 46.1302C33.2549 46.2514 32.4628 46.2756 25.7826 46.2756C19.1024 46.2756 18.3125 46.2514 15.6765 46.1302ZM15.4694 0.932162C12.8064 1.05336 10.9867 1.47536 9.39755 2.09336C7.75177 2.73156 6.35853 3.58776 4.9663 4.97696C3.57406 6.36616 2.71955 7.76076 2.08097 9.40556C1.46259 10.9948 1.04034 12.8124 0.919069 15.4738C0.795795 18.1394 0.767578 18.9916 0.767578 25.7808C0.767578 32.57 0.795795 33.4222 0.919069 36.0878C1.04034 38.7494 1.46259 40.5668 2.08097 42.156C2.71955 43.7998 3.57426 45.196 4.9663 46.5846C6.35833 47.9732 7.75177 48.8282 9.39755 49.4682C10.9897 50.0862 12.8064 50.5082 15.4694 50.6294C18.138 50.7506 18.9893 50.7808 25.7826 50.7808C32.5759 50.7808 33.4286 50.7526 36.0958 50.6294C38.759 50.5082 40.5774 50.0862 42.1676 49.4682C43.8124 48.8282 45.2066 47.9738 46.5989 46.5846C47.9911 45.1954 48.8438 43.7998 49.4842 42.156C50.1026 40.5668 50.5268 38.7492 50.6461 36.0878C50.7674 33.4202 50.7956 32.57 50.7956 25.7808C50.7956 18.9916 50.7674 18.1394 50.6461 15.4738C50.5248 12.8122 50.1026 10.9938 49.4842 9.40556C48.8438 7.76176 47.9889 6.36836 46.5989 4.97696C45.2088 3.58556 43.8124 2.73156 42.1696 2.09336C40.5775 1.47536 38.7588 1.05136 36.0978 0.932162C33.4306 0.810962 32.5779 0.780762 25.7846 0.780762C18.9913 0.780762 18.138 0.808962 15.4694 0.932162Z" fill="url(#paint1_radial_7092_54379)" />
                                    <defs>
                                        <radialGradient id="paint0_radial_7092_54379" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(7.41436 51.017) scale(65.31 65.2708)">
                                            <stop offset="0.09" stopColor="#FA8F21" />
                                            <stop offset="0.78" stopColor="#D82D7E" />
                                        </radialGradient>
                                        <radialGradient id="paint1_radial_7092_54379" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(31.1086 53.257) scale(51.4733 51.4424)">
                                            <stop offset="0.64" stopColor="#8C3AAA" stopOpacity="0" />
                                            <stop offset="1" stopColor="#8C3AAA" />
                                        </radialGradient>
                                    </defs>
                                </svg>
                            </a>

                            <a href="https://x.com/triokzz" role="button">
                                <svg className="cursor-pointer rounded-md shadow-md shadow-transparent transition-all duration-300 hover:shadow-indigo-200" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 93 92" fill="none">
                                    <rect x="0.138672" width="91.5618" height="91.5618" rx="15" fill="#F7F7F7" />
                                    <path d="M50.7568 42.1716L69.3704 21H64.9596L48.7974 39.383L35.8887 21H21L40.5205 48.7983L21 71H25.4111L42.4788 51.5869L56.1113 71H71L50.7557 42.1716H50.7568ZM44.7152 49.0433L42.7374 46.2752L27.0005 24.2492H33.7756L46.4755 42.0249L48.4533 44.7929L64.9617 67.8986H58.1865L44.7152 49.0443V49.0433Z" fill="black" />
                                </svg></a>
                            <a href="https://www.linkedin.com/company/triokzz" role="button">
                                <svg className="cursor-pointer rounded-md shadow-md shadow-transparent transition-all duration-300 hover:shadow-blue-200" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 92 93" fill="none">
                                    <rect x="0.138672" y="1" width="91.5618" height="91.5618" rx="15" fill="#EEFAFF" />
                                    <path fillRule="evenodd" clipRule="evenodd" d="M24.6975 21.5618C22.6561 21.5618 21 23.1674 21 25.1456V68.0091C21 69.9875 22.6563 71.5918 24.6975 71.5918H67.3325C69.3747 71.5918 71.03 69.9873 71.03 68.0086V25.1456C71.03 23.1674 69.3747 21.5618 67.3325 21.5618H24.6975ZM36.2032 40.9068V63.4304H28.7167V40.9068H36.2032ZM36.6967 33.9411C36.6967 36.1025 35.0717 37.8321 32.4615 37.8321L32.4609 37.8319H32.4124C29.8998 37.8319 28.2754 36.1023 28.2754 33.9409C28.2754 31.7304 29.9489 30.0491 32.5111 30.0491C35.0717 30.0491 36.6478 31.7304 36.6967 33.9411ZM47.833 63.4304H40.3471L40.3469 63.4312C40.3469 63.4312 40.4452 43.0205 40.3475 40.9075H47.8336V44.0957C48.8288 42.5613 50.6098 40.3787 54.5808 40.3787C59.5062 40.3787 63.1991 43.598 63.1991 50.516V63.4304H55.7133V51.3822C55.7133 48.354 54.6293 46.2887 51.921 46.2887C49.8524 46.2887 48.6206 47.6815 48.0796 49.0271C47.8819 49.5072 47.833 50.1813 47.833 50.8535V63.4304Z" fill="#006699" />
                                </svg>
                            </a>
                            <div className="flex float-right md:w-auto h-12" tabIndex="0">
                                <a aria-label="Download on the Google Play Store"
                                    className="rounded-2xl p-2 flex items-center w-38 sm:w-48 md:w-38 bg-white text-gray-900 hover:bg-gray-50"
                                    href="https://play.google.com/store/apps/details?id=com.triokzz.app" target="_blank" rel="noopener noreferrer">
                                    <svg width="100%" viewBox="0 0 132 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M107.104 31.6918H109.041V18.4767H107.104V31.6918ZM124.55 23.2375L122.33 28.9665H122.263L119.959 23.2375H117.873L121.329 31.2447L119.358 35.699H121.378L126.704 23.2378L124.55 23.2375ZM113.565 30.1908C112.932 30.1908 112.046 29.8674 112.046 29.0685C112.046 28.0485 113.149 27.6575 114.099 27.6575C114.951 27.6575 115.352 27.8442 115.869 28.0994C115.719 29.3236 114.684 30.1908 113.565 30.1908ZM113.799 22.9484C112.397 22.9484 110.945 23.5776 110.344 24.9717L112.063 25.7025C112.43 24.9717 113.114 24.7339 113.833 24.7339C114.834 24.7339 115.853 25.3454 115.869 26.4338V26.5696C115.518 26.3656 114.767 26.0597 113.849 26.0597C111.995 26.0597 110.109 27.0965 110.109 29.0346C110.109 30.8027 111.629 31.9419 113.331 31.9419C114.633 31.9419 115.352 31.3468 115.802 30.6495H115.869V31.6702H117.74V26.6034C117.74 24.2573 116.019 22.9484 113.799 22.9484ZM101.829 24.8461H99.0737V20.3166H101.829C103.277 20.3166 104.099 21.5372 104.099 22.5813C104.099 23.6054 103.277 24.8461 101.829 24.8461ZM101.779 18.477H97.1377V31.6922H99.0738V26.6857H101.779C103.926 26.6857 106.036 25.1035 106.036 22.5818C106.036 20.0606 103.926 18.477 101.779 18.477ZM76.4709 30.193C75.1328 30.193 74.0128 29.0517 74.0128 27.4856C74.0128 25.9012 75.1328 24.7438 76.4709 24.7438C77.792 24.7438 78.8288 25.9013 78.8288 27.4856C78.8288 29.0517 77.792 30.193 76.4709 30.193ZM78.695 23.9772H78.628C78.1934 23.4494 77.3568 22.9726 76.3038 22.9726C74.096 22.9726 72.0726 24.9483 72.0726 27.4856C72.0726 30.0056 74.096 31.9639 76.3038 31.9639C77.3568 31.9639 78.1933 31.487 78.628 30.9424H78.695V31.589C78.695 33.3096 77.792 34.2287 76.3371 34.2287C75.1502 34.2287 74.4143 33.3603 74.113 32.6282L72.4243 33.3433C72.9088 34.5349 74.1962 36 76.3372 36C78.6119 36 80.535 34.6373 80.535 31.3164V23.2449H78.695L78.695 23.9772ZM81.8731 31.6914H83.8121V18.4763H81.8731V31.6914ZM86.672 27.332C86.6221 25.5949 87.9938 24.7096 88.98 24.7096C89.7496 24.7096 90.4011 25.1014 90.6194 25.663L86.672 27.332ZM92.6921 25.8331C92.3244 24.829 91.204 22.9726 88.913 22.9726C86.6383 22.9726 84.7488 24.7947 84.7488 27.4683C84.7488 29.9887 86.6221 31.964 89.13 31.964C91.1534 31.964 92.3244 30.7042 92.8097 29.9717L91.3045 28.9498C90.8027 29.6992 90.1174 30.1931 89.13 30.1931C88.1439 30.1931 87.4412 29.7331 86.9904 28.8306L92.8928 26.3444L92.6921 25.8331ZM45.6614 24.352V26.2593H50.1431C50.0093 27.3321 49.6581 28.1153 49.1229 28.6603C48.4705 29.3243 47.4504 30.0568 45.6614 30.0568C42.902 30.0568 40.7449 27.792 40.7449 24.9822C40.7449 22.1723 42.902 19.9072 45.6614 19.9072C47.1498 19.9072 48.2365 20.5034 49.0393 21.2697L50.3608 19.9241C49.24 18.8344 47.7519 18 45.6614 18C41.8814 18 38.7041 21.1334 38.7041 24.9822C38.7041 28.8305 41.8814 31.964 45.6614 31.964C47.7013 31.964 49.2401 31.2827 50.4439 30.0056C51.6815 28.7454 52.0662 26.9745 52.0662 25.5438C52.0662 25.1015 52.0325 24.6928 51.9656 24.352H45.6614ZM57.162 30.193C55.8238 30.193 54.6699 29.069 54.6699 27.4683C54.6699 25.8505 55.8238 24.7439 57.162 24.7439C58.4996 24.7439 59.6536 25.8505 59.6536 27.4683C59.6536 29.069 58.4996 30.193 57.162 30.193ZM57.162 22.9726C54.7197 22.9726 52.73 24.8628 52.73 27.4683C52.73 30.0568 54.7197 31.964 57.162 31.964C59.6033 31.964 61.5934 30.0568 61.5934 27.4683C61.5934 24.8628 59.6033 22.9726 57.162 22.9726ZM66.8291 30.193C65.4919 30.193 64.3375 29.069 64.3375 27.4683C64.3375 25.8505 65.492 24.7439 66.8291 24.7439C68.1673 24.7439 69.3208 25.8505 69.3208 27.4683C69.3208 29.069 68.1673 30.193 66.8291 30.193ZM66.8291 22.9726C64.3878 22.9726 62.3981 24.8628 62.3981 27.4683C62.3981 30.0568 64.3878 31.964 66.8291 31.964C69.2714 31.964 71.2611 30.0568 71.2611 27.4683C71.2611 24.8628 69.2714 22.9726 66.8291 22.9726Z"
                                            fill="black"></path>
                                        <path
                                            d="M17.1955 20.2345L6.10352 32.008C6.10393 32.0104 6.10477 32.0124 6.10516 32.0149C6.44534 33.2934 7.61306 34.2347 8.9989 34.2347C9.55289 34.2347 10.073 34.085 10.5191 33.822L10.5545 33.8013L23.0406 26.5962L17.1955 20.2345Z"
                                            fill="#EB3131"></path>
                                        <path
                                            d="M28.4174 18.23L28.4068 18.2227L23.0161 15.0977L16.9429 20.5019L23.0372 26.5955L28.3994 23.5015C29.3395 22.994 29.9778 22.0029 29.9778 20.8601C29.9778 19.7254 29.3482 18.7392 28.4174 18.23Z"
                                            fill="#F6B60B"></path>
                                        <path
                                            d="M6.10173 9.66211C6.03505 9.908 6 10.1656 6 10.433V31.2378C6 31.5048 6.03463 31.7632 6.10215 32.0082L17.5771 20.5356L6.10173 9.66211Z"
                                            fill="#5778C5"></path>
                                        <path
                                            d="M17.2769 20.8353L23.0186 15.0954L10.5465 7.86427C10.0931 7.59274 9.56402 7.43604 8.99785 7.43604C7.61201 7.43604 6.44272 8.3791 6.10247 9.65905C6.10205 9.6603 6.10205 9.66116 6.10205 9.66225L17.2769 20.8353Z"
                                            fill="#3BAD49"></path>
                                        <path
                                            d="M44.9244 10.2667H41.922V11.0704H44.1719C44.1107 11.7263 43.8695 12.2412 43.4626 12.6152C43.0558 12.9892 42.5363 13.177 41.922 13.177C41.2482 13.177 40.6773 12.9231 40.2094 12.4187C39.751 11.9038 39.5179 11.267 39.5179 10.4999C39.5179 9.73287 39.751 9.09613 40.2094 8.58127C40.6773 8.07684 41.2482 7.82457 41.922 7.82457C42.2678 7.82457 42.5975 7.88892 42.8997 8.02986C43.2021 8.17069 43.4449 8.3673 43.6347 8.61958L44.2056 8.00203C43.9467 7.68363 43.6186 7.44014 43.2117 7.26269C42.8048 7.08523 42.3803 7.00006 41.9219 7.00006C41.023 7.00006 40.2608 7.3375 39.6384 8.01074C39.0161 8.68562 38.7041 9.51716 38.7041 10.4999C38.7041 11.4827 39.0161 12.3161 39.6384 12.9893C40.2608 13.6624 41.023 14 41.9219 14C42.8659 14 43.6186 13.6729 44.1975 13.0084C44.7073 12.4553 44.9678 11.7073 44.9678 10.7714C44.9678 10.6131 44.9501 10.4442 44.9244 10.2667ZM46.0875 7.14951V13.8503H49.7042V13.0274H46.8836V10.9018H49.4277V10.0981H46.8836V7.97411H49.7042V7.14949L46.0875 7.14951ZM54.7755 7.97414V7.14951H50.5188V7.97414H52.2492V13.8503H53.0452V7.97414H54.7755ZM58.6294 7.14951H57.8334V13.8503H58.6294V7.14951ZM63.8836 7.97414V7.14951H59.6269V7.97414H61.3571V13.8503H62.1531V7.97414H63.8836ZM71.9162 8.02112C71.3019 7.33745 70.5493 7 69.6503 7C68.7498 7 67.9972 7.33744 67.3828 8.01068C66.7685 8.67521 66.4663 9.50841 66.4663 10.4999C66.4663 11.4914 66.7685 12.3247 67.3828 12.9893C67.9972 13.6624 68.7498 13.9999 69.6503 13.9999C70.5412 13.9999 71.3018 13.6624 71.9162 12.9893C72.5305 12.3247 72.8328 11.4914 72.8328 10.4999C72.8328 9.5171 72.5305 8.68552 71.9162 8.02112ZM67.9538 8.58122C68.4121 8.07678 68.9749 7.82451 69.6503 7.82451C70.3241 7.82451 70.887 8.07679 71.3372 8.58122C71.7956 9.07697 72.0206 9.72399 72.0206 10.4999C72.0206 11.2775 71.7956 11.9228 71.3372 12.4186C70.887 12.923 70.3241 13.177 69.6503 13.177C68.9749 13.177 68.412 12.923 67.9538 12.4186C67.505 11.9124 67.2799 11.2775 67.2799 10.4999C67.2799 9.72401 67.505 9.08739 67.9538 8.58122ZM74.724 9.67715L74.6903 8.38457H74.724L77.8727 13.8502H78.7041V7.14945H77.9081V11.0703L77.9418 12.3629H77.9081L74.8977 7.14945H73.928V13.8502H74.724V9.67715Z"
                                            fill="black" stroke="black" strokeWidth="0.26666" strokeMiterlimit="10"></path>
                                    </svg>
                                </a>

                            </div>
                        </div>

                    </div>
                </div>
            </footer>
        </main>

    )
}
export default ProductPage;